import { Accordion, Collapse, AccordionSummary, AccordionDetails, Box, Dialog, Menu, MenuItem, AppBar, ListItemText,Chip, Toolbar, ListItemIcon, TableContainer, Checkbox, Modal, DialogActions, DialogContent, Table, TableHead, TableBody, TableRow, TableCell, useTheme, Tooltip, FormControl, Card, Autocomplete, Grid, Typography, Stack, Divider, TextField, CardContent, IconButton, Button, alpha, Pagination, useMediaQuery } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";

import Close from '@mui/icons-material/Close';

import { ExpandMore, ExpandLess, DoubleArrowRounded, Edit } from '@mui/icons-material';
import Header from "../../../Layout/Header";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';


import { tokens } from "../../../theme/theme";
import CallAlertBar from "../../../Layout/Alertbar";
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';

import qrcode from 'qrcode';
import { useTranslation } from "react-i18next";
import QualityCheckRejectProcee from "../qc/QCRejectReelProcess";

import CloseIcon from '@mui/icons-material/Close';
import GlobalConfig from "../../../config/date/GlobalConfig";
import Searchicon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ImportExportIcon from '@mui/icons-material/ImportExport';

import ListAltIcon from '@mui/icons-material/ListAlt';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import RefreshIcon from '@mui/icons-material/Refresh';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import EditSquareIcon from '@mui/icons-material/Edit';


import InfoIcon from '@mui/icons-material/Info';
import LabelReamPalletDetails from "../labels/ReamPallet";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import useUpdateReamPalletGrossWeight from "../../../hooks/useReamPalletUpdateGrossWeight";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import TableFilterRow from "../../../components/table/TableFilterRow";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { el } from "date-fns/locale";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";

const ReamPalletLabel = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, } = useTranslation();



    const [sheeterSelectedChildRoll, setSheeterSelectedChildRoll] = useState(null);
    const [loading, setLoading] = useState(false);

    // message 
    const [sheeterMsgOpen, setSheeterMsgOpen] = useState(false);
    const [sheeterSeverityvalue, setSheeterSeverityvalue] = useState('info');
    const [sheeterMessageValue, setSheeterMessageValue] = useState('');
    const [sheeterAlertTitleValue, setSheeterAlertTitleValue] = useState('');
    const [rows, setRows] = useState(/* initial rows */);
    const userPermissions = useUserPermissions();
    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setSheeterSeverityvalue(serverityval);
        setSheeterMessageValue(msg);
        setSheeterAlertTitleValue(title);
        setSheeterMsgOpen(true);
    };

    // pallet details
    const [palletID, setPalletID] = useState(0);

    const [palletStatus, setPalletStatus] = useState('');

    const [numberofReams, setNumberOfReams] = useState(0);
    const [lossReams, setlossReams] = useState(0);

    const [numberofSheets, setNumberOfSheets] = useState(0);

    const [reamWeignt, setReamWeight] = useState(0);
    const [lReamWeignt, setLReamWeight] = useState(0);



    const [approvedPalletNumber, setApprovedPalletNumber] = useState([]);
    const [totalReams, setTotalReams] = useState(0);
    const [balanceSheet, setBalanceSheet] = useState(0);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false);
    const [disbleSheetValue, setDisbleSheetValue] = useState(false);
    const [selectedReamDetails, setSelectedReamDetails] = useState(null);
    const [viewSheeterchildRollDetail, setviewSheeterchildRollDetail] = useState(false);
    // table data view 
    const sizecolumns = ['SNo', 'ReamNumber', 'Ream Weight', 'Sheets', 'Status'];
    const [selectedReam, setSelectedReam] = useState(null);
    const [selectedReamDetailsQR, setSelectedReamDetailsQR] = useState(null);
    const [viewQRCodeDetails, setViewQRCodeDetails] = useState(false);
    const [viewReamLabeling, setViewReamLabeling] = useState(false);
    const [selectedButton, setSelectedButton] = useState(null);
    const [viewReamsList, setViewReamsList] = useState(false);

    const [reamList, setReamList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');

    // reject reason
    const [rejectReason, setRejectReason] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [rejectProductType, setRejectProductType] = useState(null);
    const [rejectStatus, setRejectStatus] = useState(false);
    const [rejectReasonID, setRejectReasonID] = useState(0);
    const [rejectRemarks, setRejectRemarks] = useState(null);
    const [enableReject, setEnableReject] = useState(false);

    const [period, setPeriod] = useState('Today');
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [selectedRows, setSelectedRows] = useState([]);


    const [errorMessage, setErrorMessage] = useState('');
    const [shiftdate_errorMessage, setshiftdate_errorMessage] = useState('');

    const [shiftCodes, setShiftCodes] = useState([]);
    const [winderOperators, setWinderOperators] = useState('');
    const [winderShiftCode, setWinderShiftCode] = useState('');
    const [winderShiftID, setWinderShiftID] = useState(0);
    const [winderShiftDate, setWinderShiftDate] = useState(dayjs());
    const [shiftDate, setShiftDate] = useState(dayjs());
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    // OPERATORS
    const [operator, setOperator] = useState([]);
    const [fNo, setFNo] = useState(0);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [selectedOperatorName, setSelectedOperatorName] = useState([]);
    const [operatorID, setOperatorID] = useState([]);
    const [isOperatorDataLoaded, setIsOperatorDataLoaded] = useState(false);


    const [disableNumberofSheets, setDisableNumberofSheets] = useState(false);

    const [sheeterNoOfSheets, setSheeterNoOfSheets] = useState(0);
    const [viewReamQRCode, setViewReamQRCode] = useState(false);
    const [selectedReamRows, setSelectedReamRows] = useState([]);

    const [summaryList, setSummaryList] = useState([]);
    const [maxWightBundle, setMaxWeightBundle] = useState(55);
    const [bundleDetails, setBundleDetails] = useState([]);
    const [bundleList, setBundleList] = useState([]);
    const [bundleWiseReam, setBundleWiseReam] = useState([]);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Ream Pallet Punching Summary');
    const openFirst = Boolean(anchorElFirst);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);
    const [reamPalletListLoding, setReamPalletListLoading] = useState(false);

    const [filterIndentno, setFilterIndentno] = useState('');
    const [indentNoList, setIndentNoList] = useState([]);

    const [expandedRow, setExpandedRow] = useState(null);  // Track which row is expanded
    const [expandedData, setExpandedData] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page

    // Responsive breakpoints
    const isXs = useMediaQuery((theme) => theme.breakpoints.only("xs"));
    const isSm = useMediaQuery((theme) => theme.breakpoints.only("sm"));
    const isMd = useMediaQuery((theme) => theme.breakpoints.only("md"));
    const isLg = useMediaQuery((theme) => theme.breakpoints.only("lg"));
    const isXl = useMediaQuery((theme) => theme.breakpoints.only("xl"));


    // Update recordsPerPage based on screen size
    useEffect(() => {
        if (isXs) setRecordsPerPage(20);
        else if (isSm) setRecordsPerPage(10);
        else if (isMd) setRecordsPerPage(10);
        else if (isLg) setRecordsPerPage(15);
        else if (isXl) setRecordsPerPage(27);
    }, [isXs, isSm, isMd, isLg, isXl]);
    //
    const { processIndent, updateApproveList, setUpdateAppeovedList } = useUpdateReamPalletGrossWeight(callError);

    const [uniqueCrNumbers, setUniqueCrNumbers] = useState([]);
    const [cr_number, setcr_number] = useState([]);

    const [filteredReelData, setFilteredReelData] = useState([]);

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        LoadOrderItemDetails(date, ToDate);
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        LoadOrderItemDetails(FromDate, date);
    };

    const handleCRNumberChange = (event, value) => {
        // If `value` is a single string:

        if (!value || value.length === 0) {
            // Reset to original reelList if value is null or empty
            setFilteredReelData(reelList);
            setcr_number(value);
        }
        else if (typeof value === 'string') {
            setFilteredReelData(reelList.filter((row) => row.cr_number === value));
            setcr_number(value);
        }
        // If `value` is an array:
        else if (Array.isArray(value)) {
            setFilteredReelData(reelList.filter((row) => value.includes(row.cr_number)));
            setcr_number(value);
        }
    };


    const handleExpandRow = async (row) => {
        const { indent_no } = row;
        // Toggle expansion
        if (expandedRow === indent_no) {
            setExpandedRow(null);
            return;
        }

        try {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_indent_no: row.indent_no,
                p_line_no: row.line_no,
                p_release_no: 0,
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setExpandedData((prev) => ({ ...prev, [indent_no]: data }));
                        setExpandedRow(indent_no);

                        console.log('test', expandedData)
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        } catch (error) {
            console.error("Failed to fetch expanded row data", error);
        }
    };




    const fetchIndentNo = async () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 0,
        }

        try {
            const data = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DISTINCT_ORDERITEM_BUNDLE_PUNCHING, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setIndentNoList(data);
            }
        }
        catch (error) {
            alert(error);
        }
    }


    useEffect(() => {
        fetchIndentNo();
    }, [])


    const handleIndentNoChange = (event, value) => {
        if (value !== undefined && value != null) {
            setFilterIndentno(value);
            LoadOrderItemDetailsFilterByCONumber(value.indent_no);
        }
        else {
            setFilterIndentno('');
            LoadOrderItemDetails();
        }
    }


    const LoadOrderItemDetailsFilterByCONumber = (indent_no) => {

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_indent_no: indent_no
        };


        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS_BY_CONUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);

                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');

                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');

            });
    }

    const LoadOrderItemDetails = (FromDate, ToDate) => {
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate
        };

        setLoadingOrderItemDet(true);
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS_REAM_PALLET, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                    setLoadingOrderItemDet(false);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });
    }

    // const LoadOrderItemDetails = () => {
    //     // Date filter

    //     const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
    //     const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
    //     const p_mono = 0;

    //     const orderData = {
    //         p_companyid: localStorage.getItem('companyid'),
    //         p_plantid: 1,
    //         p_release_no: p_mono,
    //         p_frommodate,
    //         p_tomodate
    //     };



    //     callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
    //         .then(data => {
    //             if (data && data.length > 0) {
    //                 // Update state with fetched data
    //                 setPartyList(data);
    //                 setViewLineItemList(true);
    //             } else {
    //                 // No data found
    //                 setPartyList([]);
    //                 setViewLineItemList(false);
    //                 callError('info', 'No MO are released this date range, Kindly adjust data range.', 'info');
    //             }
    //         })
    //         .catch(error => {
    //             // Update state with error message        
    //             callError('error', error.message, 'Error');
    //         });

    // }

    // Handlers for first menu



    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Ream Pallet Punching') {
            setSelectedStatus('All');
        }
        else if (option === 'Unweighted Reels') {
            setSelectedStatus('Booked');
        }
        else if (option === 'FG Child Roll') {
            setSelectedStatus('fg');
        }
        else if (option === 'Inprogress Child Roll') {
            setSelectedStatus('wip');
        }
        else if (option === 'Cancelled Child Roll') {
            setSelectedStatus('cancelled');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setJobID(0);
        setViewJob(false);
        setViewReamQRCode(false);
        setNewJob(true);
        setviewReamProcess(false);
        setViewLineItemList(true);
        setviewPalletList(false);

    }





    const callback = () => {
        handleBackWinderMachineEntry();
    };



    // filter data new concept
    const [filters, setFilters] = useState({
        pr_number: '',
        release_no: '',
        // email: '',
        // workphone: '',
        status: '',
        // payales: '',
    });

    const ReverseReams = () => {
        setSheeterMsgOpen(false);
        let isvalid = true;
        let validation_msg = '';

        // validation Process

        if (numberofSheets === 0) {
            validation_msg += 'Please Enter Number of Sheets in Reams.\n';
            isvalid = false;
        }

        // Remove trailing newline character if any
        validation_msg = validation_msg.trim();

        if (isvalid == true) {

            const orderData = {
                p_companyid: 1,
                p_total_reams: totalReams,

            };


            // GET REAM NUMBER
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_NUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {

                    // update ream number to ream table
                    if (data && data.length > 0) {
                        // preceed to add new reams
                        console.table(data);
                        let ream_number_end = data[0].lot_number;
                        let ream_number_start = ream_number_end - totalReams;


                        const reamData = {
                            p_companyid: 1,
                            p_plant_id: localStorage.getItem('companyid'),
                            p_total_reams: numberofReams,
                            p_pallet_id: palletID,
                            p_number_of_sheets: numberofSheets,
                            p_loss_reams: lossReams,
                            p_loss_reams_sheets: balanceSheet,
                            p_created_by: localStorage.getItem('userID'),
                            p_reject_ream_status: false,
                            p_ream_number_start: ream_number_start,
                            p_ream_weight: reamWeignt,
                            p_l_ream_weight: lReamWeignt,
                            p_process_id: 1
                        };


                        // create reams                   
                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_CREATE_REAM, 'POST', { 'Content-Type': 'application/json' }, reamData)
                            .then(data => {
                                if (data && data.length > 0) {
                                    // setApprovedPalletNumber(data);
                                    // //setviewSheeterchildRollSummaryDetail(true);
                                    // setSheeterSeverityvalue('info');
                                    // setSheeterMessageValue('Ream number created .');
                                    // setSheeterAlertTitleValue('info');
                                    // setSheeterMsgOpen(true);

                                    // setViewReamsList(true);
                                    // setDisableSaveBtn(true);
                                    // setDisbleSheetValue(true);
                                    // setPalletStatus('Completed')
                                    setSheeterSeverityvalue('info');
                                    setSheeterMessageValue('Ream number reverse process failed.');
                                    setSheeterAlertTitleValue('info');
                                    setSheeterMsgOpen(true);

                                }
                                else {
                                    setApprovedPalletNumber([]);
                                    setSheeterSeverityvalue('info');
                                    setSheeterMessageValue('Ream number reverse process success.');
                                    setSheeterAlertTitleValue('info');
                                    setSheeterMsgOpen(true);
                                    setViewReamsList(false);
                                    setDisableSaveBtn(false);
                                    setDisbleSheetValue(false);
                                    setPalletStatus('wip')
                                    //setviewSheeterchildRollSummaryDetail(false);
                                }
                            })
                            .catch(error => {
                                alert(error.message);
                                // Update state with error message        
                                setSheeterSeverityvalue('error');
                                setSheeterMessageValue(error.message);
                                setSheeterAlertTitleValue('Error');
                                setSheeterMsgOpen(true);
                                //setviewSheeterchildRollSummaryDetail(false);
                            });
                    }
                    else {
                        // set error message
                        alert('no data found..');
                    }

                })
                .catch(error => {
                    // Update state with error message       
                    setSheeterSeverityvalue('error');
                    setSheeterMessageValue(error.message);
                    setSheeterAlertTitleValue('Error');
                    setSheeterMsgOpen(true);
                });

        }
        else {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue(validation_msg);
            setSheeterAlertTitleValue('Error');
            setSheeterMsgOpen(true);
        }

    };


    const filterData = (filter) => {
        let fromDate, toDate;
        switch (filter) {
            case 'All':
                fromDate = dayjs().subtract(4, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'Today':
                fromDate = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Week':
                fromDate = dayjs().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('week').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Month':
                fromDate = dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Quarter':
                fromDate = dayjs().startOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Year':
                fromDate = dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                fromDate = ''; // You can set a default value here
                toDate = ''; // You can set a default value here
                break;
        }

        setSheeterMsgOpen(false);
        setViewReamLabeling(false);
        setShowCard(false);
        setSheeterSelectedChildRoll(null);

        // Date filter
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = fromDate;//dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = toDate;//dayjs(orderToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "ream";
        const p_mono = 1;

        // Collect the values of the controls
        const parameter = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };






    };





    const [FromShiftDate, setFromShiftDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToShiftDate, setToShiftDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [isDataLoadeds, setIsDataLoadeds] = useState(false);

    const handleFromShiftDateChange = (date) => {
        setFromShiftDate(dayjs(date));
    };

    const handleToShiftDateChange = (date) => {
        setToShiftDate(dayjs(date));
    };

    useEffect(() => {
        if (!isDataLoadeds) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_frommodate: FromShiftDate,
                p_tomodate: ToShiftDate,
            }
            setLoading(true);
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_PALLET_PROCESS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setSummaryList(data);
                        setLoading(false);
                    }
                    else {
                        setSummaryList([]);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    alert(error.message);
                    setLoading(false);
                });

        }
    }, [isDataLoadeds, FromShiftDate, ToShiftDate, setFromShiftDate, setToShiftDate]);


    const LoadJobList = () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: FromShiftDate,
            p_tomodate: ToShiftDate,
        }
        setLoading(true);
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_PALLET_PROCESS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setSummaryList(data);
                    setLoading(false);
                }
                else { setLoading(false); }
            })
            .catch(error => {
                alert(error.message);
                setLoading(false);
            });
    }


    const handleUpdate = async () => {
        try {
            const para = {
                p_companyid: localStorage.getItem("companyid"),
                p_id_operator: operatorID,
                p_user: localStorage.getItem("userID"),
                p_fno: fNo,
                p_job_number: jobID,
                p_plantid: 1


            };

            const response = await callApi(
                API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_REAM_PALLET_PUNCHING_JOB_NUMBER,
                "POST",
                { "Content-Type": "application/json" },
                para
            );

            if (response && response.length > 0) {
                setSheeterSeverityvalue("success");
                setSheeterMessageValue("Ream Pallet updated successfully");
                setSheeterAlertTitleValue("Success");
                setSheeterMsgOpen(true);
            } else {
                throw new Error("Update failed");
            }
        } catch (error) {
            setSheeterSeverityvalue("error");
            setSheeterMessageValue(error.message);
            setSheeterAlertTitleValue("Error");
            setSheeterMsgOpen(true);
        }
    };


    const handleButtonClick = async (buttonName) => {
        setSelectedButton(buttonName);
        setSheeterMsgOpen(false);

        // let printselectedPalletDetails = approvedPalletNumber;
        let printselectedBundleDetails = reamList;
        let isvalid = true;

        if (printselectedBundleDetails.length === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!selectedReamDetails || selectedReamDetails.length === 0)) {
            isvalid = false;

            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
        }


        // filter data      
        printselectedBundleDetails = reamList.filter((ream) => selectedReamRows.includes(ream.id_ream_pallet_val));

        if (printselectedBundleDetails.length === 0) {
            isvalid = false;
            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select ream code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
            return;
        }


        if (isvalid == true) {
            if (printselectedBundleDetails.length > 0) {
                const printWindow = window.open('', '_blank');
                try {
                    // Generate HTML content for each QR code
                    for (const qrCodeValue of printselectedBundleDetails) {
                        // Generate QR code data URL
                        const qrDataUrl = await generateQRCode(qrCodeValue.ream_pallet_number);
                        // Check if QR code generation was successful
                        if (!qrDataUrl) {
                            console.error('Error generating QR code for value:', qrCodeValue.ream_pallet_number);
                            continue; // Skip to the next QR code
                        }

                        let grossweight = qrCodeValue.ream_pallet_gross_weight;
                        // Write HTML content to the print window
                        printWindow.document.write(`

                                        <html>
                                            <head>
                                                
                                            <style>
                                                @page {
                                                    size: A4;
                                                    margin: 5mm;
                                                }

                                                body {
                                                    margin: 0;
                                                    padding: 5px;
                                                    font-family: Arial, sans-serif;
                                                    background-color: #f4f4f4;
                                                    font-size: 60px; /* Base font size increased */
                                                }

                                                .container {
                                                    display: flex;
                                                    align-items: flex-start;
                                                    justify-content: flex-start;
                                                    padding: 10px;
                                                    background-color: white;
                                                    width: 100%;
                                                    box-sizing: border-box;
                                                   
                                                }

                                                .bundle-details {
                                                    flex: 1;
                                                    margin-left: 10px;
                                                }

                                                .bundle-details h5 {
                                                    margin: 0;
                                                    font-size: 30px; /* Even bigger heading */
                                                    font-weight: bold;
                                                }

                                                .details-table {
                                                    display: grid;
                                                    grid-template-columns: 370px auto; /* Wider label column */
                                                    gap: 0;
                                                    margin-top: 2cm;
                                                    border: 2px solid #000; /* Thicker outer border */
                                                    width: 100%;
                                                    box-sizing: border-box;
                                                }

                                                .details-table > div {
                                                    font-size:30px; /* Increased font size for all cells */
                                                    border: 1px solid #000;
                                                    padding: 12px 14px; /* More padding for print clarity */
                                                    box-sizing: border-box;
                                                    word-break: break-word;
                                                }

                                                .details-table .label {
                                                    font-weight: bold;
                                                    background-color: #eaeaea;
                                                
                                                }

                                                @media print {
                                                    body {
                                                        background-color: white;
                                                    }

                                                    .details-table .label {
                                                        background-color: #eaeaea !important;
                                                        -webkit-print-color-adjust: exact;
                                                        print-color-adjust: exact;
                                                    }
                                                }
                                                    
                                                .container {
                                                        page-break-after: always;
                                                       
                                                    }
                                            </style>     
                                            
                                            </head>
                                            <body>
                                                <div class="container">
                                                    <div class="bundle-details">
                                                        <div class="details-table">
                                                            <div class="label">PRODUCT</div> <div>: ${qrCodeValue.item_code}</div>   
                                                            <div class="label">PACKED DATE</div><div>: ${qrCodeValue.shift_date}</div> 
                                                            <div class="label">LOT NO</div><div>: ${qrCodeValue.pr_number || '0'}</div>  
                                                            <div class="label">GSM</div><div>: ${qrCodeValue.gsm || ''}</div>
                                                            <div class="label">SIZE</div><div>: ${qrCodeValue.size || ''}</div> 
                                                            <div class="label">NO OF REAM / SHEET</div><div>: ${qrCodeValue.no_of_reams || 0} / ${qrCodeValue.sheets_in_reams || 0}</div>                                         
                                                            <div class="label">NET WEIGHT (KG)</div><div>: ${qrCodeValue.ream_pallet_weight || 0}</div>  
                                                            <div class="label">GROSS WEIGHT (KG)</div><div>: ${grossweight || 0}</div>     
                                                            <div class="label">REAM PALLET NO</div><div>: ${qrCodeValue.ream_pallet_number}</div>                   
                                                                                                
                                                            
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </body>
                                            </html>

                                    `);




                    }
                    // Close the print window and print the report

                    printWindow.document.close();
                    printWindow.print();

                } catch (error) {
                    console.error('Error handling button click:', error);
                }
            }


        }

    };

    const handleButtonClickNew = async (buttonName) => {
        setSelectedButton(buttonName);
        setSheeterMsgOpen(false);

        // let printselectedPalletDetails = approvedPalletNumber;
        let printselectedBundleDetails = reamList;
        let isvalid = true;

        if (printselectedBundleDetails.length === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!selectedReamDetails || selectedReamDetails.length === 0)) {
            isvalid = false;

            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
        }


        // filter data      
        printselectedBundleDetails = reamList.filter((ream) => selectedReamRows.includes(ream.id_ream_pallet_val));

        if (printselectedBundleDetails.length === 0) {
            isvalid = false;
            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select ream code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
            return;
        }


        if (isvalid == true) {
            if (printselectedBundleDetails.length > 0) {
                const printWindow = window.open('', '_blank');
                try {
                    // Write HTML head once
                    printWindow.document.write(`
                        <html>
                            <head>
                                <style>
                                    @page {
                                        size: 206mm 306mm;
                                        margin: 3mm;
                                    }

                                    body {
                                        margin: 0;
                                        padding: 0;
                                        font-family: Arial, sans-serif;
                                        background-color: white;
                                    }

                                    .container {
                                        width: 200mm;
                                        height: 300mm;
                                        box-sizing: border-box;
                                        background-color: white;
                                        border: 2px solid #000;
                                        page-break-after: always;
                                        display: flex;
                                        flex-direction: column;
                                        overflow: hidden;
                                    }

                                    /* ── Header space (client will paste their logo here) ── */
                                    .header-space {
                                        height: 92mm;
                                        min-height: 92mm;
                                        flex-shrink: 0;
                                        border-bottom: 2px solid #000;
                                        background-color: white;
                                    }

                                    /* ── Details table ── */
                                    .details-table {
                                        display: grid;
                                        grid-template-columns: 42% 58%;
                                        grid-template-rows: 1fr 1fr 1fr 2.5fr 1fr 1fr 1fr 1fr 1fr 1fr;
                                        min-height: 0;
                                        gap: 0;
                                        flex: 1;
                                        width: 100%;
                                        box-sizing: border-box;
                                        background-color: white;
                                        overflow: hidden;
                                    }

                                    .details-table > div {
                                        font-size: 30px;
                                        font-family: Arial, sans-serif;
                                        border: 1px solid #000;
                                        padding: 4px 10px;
                                        box-sizing: border-box;
                                        word-break: break-word;
                                        background-color: white;
                                        display: flex;
                                        align-items: center;
                                    }

                                    .details-table .label {
                                        font-weight: bold;
                                        font-size: 27px;
                                        letter-spacing: 0.3px;
                                        background-color: white;
                                    }

                                    .details-table .value {
                                        font-size: 32px;
                                    }

                                    @media print {
                                        body { background-color: white; }

                                        .container {
                                            border: 2px solid #000 !important;
                                            -webkit-print-color-adjust: exact;
                                            print-color-adjust: exact;
                                        }

                                        .details-table > div,
                                        .details-table .label {
                                            background-color: white !important;
                                            -webkit-print-color-adjust: exact;
                                            print-color-adjust: exact;
                                        }
                                    }
                                </style>
                            </head>
                            <body>
                    `);

                    // Generate HTML content for each QR code
                    for (const qrCodeValue of printselectedBundleDetails) {
                        // Generate QR code data URL
                        const qrDataUrl = await generateQRCode(qrCodeValue.ream_pallet_number);
                        // Check if QR code generation was successful
                        if (!qrDataUrl) {
                            console.error('Error generating QR code for value:', qrCodeValue.ream_pallet_number);
                            continue;
                        }

                        let grossweight = qrCodeValue.ream_pallet_gross_weight;
                        // Write HTML content for each item
                        printWindow.document.write(`
                            <div class="container">

                                <!-- ── Empty header space for client logo ── -->
                                <div class="header-space"></div>

                                <!-- ── Details table ── -->
                                <div class="details-table">
                                    <div class="label">PRODUCT</div><div class="value">${qrCodeValue.item_code}</div>
                                    <div class="label">PACKED DATE</div><div class="value">${qrCodeValue.shift_date}</div>
                                    <div class="label">LOT NO</div><div class="value">${qrCodeValue.pr_number || '0'}</div>
                                    <div class="label" style="flex-direction:column;align-items:flex-start;justify-content:center;gap:6px;"><span>PALLET NO.</span><img src="${qrDataUrl}" alt="QR Code" style="width:110px;height:110px;display:block;"/></div><div class="value" style="font-size:54px;font-weight:bold;line-height:1.1;">${qrCodeValue.ream_pallet_number}</div>
                                    <div class="label">SIZE (CM)</div><div class="value">${qrCodeValue.size || ''}</div>
                                    <div class="label">GSM</div><div class="value">${qrCodeValue.gsm || ''}</div>
                                    <div class="label">NO OF REAM / SHEET</div><div class="value">${qrCodeValue.no_of_reams || 0} / ${qrCodeValue.sheets_in_reams || 0}</div>
                                    <div class="label">NET WEIGHT (KG)</div><div class="value">${qrCodeValue.ream_pallet_weight || 0}</div>
                                    <div class="label">GROSS WEIGHT (KG)</div><div class="value">${grossweight || 0}</div>
                                    <div class="label" style="grid-column:span 2;justify-content:center;font-size:32px;font-weight:bold;letter-spacing:2px;">MADE IN INDIA</div>
                                </div>

                            </div>
                        `);
                    }

                    // Close the HTML body and document
                    printWindow.document.write(`
                            </body>
                        </html>
                    `);
                    // Close the print window and print the report

                    printWindow.document.close();
                    printWindow.print();

                } catch (error) {
                    console.error('Error handling button click:', error);
                }
            }


        }

    };


    //                         printWindow.document.write(`

    //                     <html>
    //                             <head>
    //                                 <title>Printed Report</title>
    //                                  <style>
    //                                     body {
    //                                         margin: 0;
    //                                         padding: 0;
    //                                         font-family: Arial, sans-serif;
    //                                     }
    //                                     .container {
    //                                         display: flex;
    //                                         align-items: center;
    //                                         justify-content: space-between;
    //                                         padding: 10px;
    //                                         border: 1px solid #ccc;
    //                                         box-sizing: border-box;
    //                                     }
    //                                     .qr-code {
    //                                         width: 150px; /* Adjust as needed */
    //                                     }
    //                                     .bundle-details {
    //                                         flex: 1;
    //                                         margin-left: 20px; /* Adjust spacing between QR code and bundle details */
    //                                     }
    //                                     .bundle-details h5 {
    //                                         margin: 0;
    //                                         font-size: 18px;
    //                                     }
    //                                     .details-table {
    //                                         display: grid;
    //                                         grid-template-columns: 150px auto;
    //                                         gap: 10px 20px;
    //                                         margin-top: 10px;
    //                                     }
    //                                     .details-table div {
    //                                         font-size: 16px;
    //                                     }
    //                                     .details-table .label {
    //                                         font-weight: bold;
    //                                     }
    //                                     .bundle-details hr {
    //                                         margin: 10px 0;
    //                                         border: 1px solid #ccc;
    //                                     }
    //                                     /* Ensure each container goes on a new page */
    //                                     .container {
    //                                         page-break-after: always;
    //                                     }
    //                                 </style>
    //                             </head>
    //                             <body>
    //                                 <div class="container">
    //                                     <div>
    //                                         <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
    //                                         <h4 >${qrCodeValue.ream_pallet_number || 'XXXXXX0123'}</h4>
    //                                     </div>
    //                                     <div class="bundle-details">
    //                                         <h5>REAM PALLET DETAILS</h5>
    //                                         <hr/>
    //                                         <div class="details-table">
    //                                             <div class="label">DATE / SHIFT </div><div>:  ${qrCodeValue.shift_date} / ${qrCodeValue.shift_code}</div>  
    //                                             <div class="label">QUALITY</div><div>: ${qrCodeValue.item_code}</div>   
    //                                             <div class="label">REEL NO</div><div>: ${qrCodeValue.cr_number || '0'}</div>  
    //                                             <div class="label">REAM PALLET NO</div><div>: ${qrCodeValue.ream_pallet_number}</div>  
    //                                             <div class="label">REAM PALLET WT (KG)</div><div>: ${qrCodeValue.ream_pallet_weight || 0}</div>     
    //                                             <div class="label">REAMS/REAM PALLET</div><div>: ${qrCodeValue.no_of_reams || 0}</div>                        
    //                                             <div class="label">GRAIN</div><div>: ${qrCodeValue.grain || ''}</div>                                            
    //                                             <div class="label">MA NO</div><div>: ${qrCodeValue.lot_no || ''}</div>
    //                                             <div class="label">SO NO</div><div>: ${qrCodeValue.indent_no || ''}</div>
    //                                             <div class="label">CUSTOMER</div><div>: ${qrCodeValue.customer_name || ''}</div>
    //                                             <div class="label">SUPPLIER</div><div>: ${qrCodeValue.supplier_name || ''}</div>
    //                                             <div class="label">GSM</div><div>: ${qrCodeValue.gsm || ''}</div>
    //                                             <div class="label">SIZE</div><div>: ${qrCodeValue.size || ''}</div> 
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </body>
    //                         </html>


    //                     `);



    // Function to generate QR code as data URL
    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };



    const [open, setOpen] = useState(false);
    const [getRejectResult, setGetRejectResult] = useState([]);


    const closepopup = () => {
        setOpen(false);
        setSheeterMsgOpen(false);


        let reject_product_type = "Ream";
        let product_code = selectedReamDetailsQR.ream_number;
        let isvalid = true;

        if (enableReject == false) {
            isvalid = false;
        }
        else if (product_code === "") {
            isvalid = false;
        }
        else if (selectedReamDetailsQR.ream_number == "") {
            isvalid = false;
        }
        else if (selectedReamDetailsQR.status != "approved") {

            isvalid = false;
            if (selectedReamDetailsQR.status == "rejected") {
                setSheeterSeverityvalue('info');
                setSheeterMessageValue('Ream already rejected');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }
            else {
                setSheeterSeverityvalue('info');
                setSheeterMessageValue('We cannot reject this ream. The ream has already been processed for the next stage.');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }

        }


        if (isvalid) {
            // call reject reel process
            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_reject_product_type: reject_product_type,
                p_product_code: product_code,
                p_rejectReasonID: rejectReasonID,
                p_rejectRemarks: rejectRemarks,
                p_user: localStorage.getItem('userID'),
            };

            callApi(API_ENDPOINTS.DECKL_UPDATE_REJECT_REEL, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        setGetRejectResult(data);
                        setSheeterSeverityvalue('info');
                        setSheeterMessageValue('The ream has rejected.');
                        setSheeterAlertTitleValue('info');
                        setSheeterMsgOpen(true);
                        getReamList();
                    }
                })
                .catch(error => {

                });
        }
    }


    const getReamList = () => {
        //parameters
        const reamData = {
            p_companyid: localStorage.getItem('companyid'),
            p_pallet_id: palletID,
        };


        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, reamData)
            .then(data => {
                if (data && data.length > 0) {
                    setApprovedPalletNumber(data);

                    const orderData = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_ream_number: '',
                        p_mode: 1,
                        p_pallet_id: palletID
                    };

                    setReamPalletListLoading(true);

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                        .then(data => {
                            if (data && data.length > 0) {
                                setReamList(data);
                                setReamPalletListLoading(false);
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                            setReamPalletListLoading(false);
                        });

                }

            })
            .catch(error => {
                alert(error.message);
                // Update state with error message        
                setSheeterSeverityvalue('error');
                setSheeterMessageValue(error.message);
                setSheeterAlertTitleValue('Error');
                setSheeterMsgOpen(true);
                //setviewSheeterchildRollSummaryDetail(false);
            });
    };

    const filteredReamData = reamList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All') {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });





    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).replace(/ /g, "-"); // Replace spaces with hyphens
    };


    // Load child roll details
    const [childRollDetails, setChildRollDetails] = useState([]);


    const [showCard, setShowCard] = useState(false);

    const handleHide = () => {
        setShowCard(false);
        // setViewAvailableSlots(true);
        // SetViewAvailableReelList(false);
    };


    const [partyList, setPartyList] = useState([]);

    // useEffect(() => {

    //     // Date filter

    //     const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
    //     const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');

    //     const p_mono = 0;


    //     const orderData = {
    //         p_companyid: localStorage.getItem('companyid'),
    //         p_plantid: 1,
    //         p_release_no: p_mono,
    //         p_frommodate,
    //         p_tomodate
    //     };



    //     callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
    //         .then(data => {
    //             if (data && data.length > 0) {
    //                 // Update state with fetched data
    //                 setPartyList(data);
    //                 setViewLineItemList(true);
    //             } else {
    //                 // No data found
    //                 setPartyList([]);
    //                 setViewLineItemList(false);
    //                 callError('info', 'No MO are released this date range, Kindly adjust data range.', 'info');
    //             }
    //         })
    //         .catch(error => {
    //             // Update state with error message        
    //             callError('error', error.message, 'Error');
    //         });



    // }, [FromDate], [ToDate]);

    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    useEffect(() => {
        const fetchChildRollDetails = async () => {
            if (period === 'Today') {
                filterData('Today');
            }
        };
        fetchChildRollDetails();
    }, [setPeriod]);

    const [newJob, setNewJob] = useState(false);
    const [viewJob, setViewJob] = useState(true);
    const [viewLineItemList, setViewLineItemList] = useState(false);
    const [viewPalletList, setviewPalletList] = useState(false);
    const [viewReamProcess, setviewReamProcess] = useState(false);
    const [reelList, setReelList] = useState([]);
    const [selectedReelList, setSelectedReelList] = useState([]);
    const [jobID, setJobID] = useState(0);
    const [selectedLineItemDetail, setSelectedLineItemDetail] = useState([]);
    const [loadingOrderItemDet, setLoadingOrderItemDet] = useState(false);

    const LoadOrderItemDetailsWithoutLoadProgressing = (FromDate, ToDate) => {
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate
        };


        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS_REAM_PALLET, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                    setLoadingOrderItemDet(false);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });
    }

    const handleCallEdit = (indent, line) => {

        setSelectedChip('View Reel List');

        if (indent && partyList && Array.isArray(partyList)) {
            let lineItems = partyList.filter((l) => l.indent_no === indent && l.line_no === line);
            reamCalculation(lineItems);
        }
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_indent_no: indent,
            p_line_no: line,
            p_release_no: 0,

        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {


                    const allConverted = data.every(row => row.status === 'converted');
                    if (!allConverted) {
                        setReelList(data);
                        setviewPalletList(true);
                        setViewLineItemList(false);

                        // Extract unique cr_number values
                        const uniqueCrNumbers = [...new Set(data.map((item) => item.cr_number))];
                        setUniqueCrNumbers(uniqueCrNumbers);

                        setFilteredReelData(data);
                    }
                    else {
                        setReelList([]);
                        setviewPalletList(false);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                        LoadOrderItemDetailsWithoutLoadProgressing(FromDate, ToDate);
                        setUniqueCrNumbers([]);
                        setFilteredReelData([]);
                    }




                } else {
                    // No data found

                    setReelList([]);
                    setFilteredReelData([]);
                    setviewPalletList(false);
                    LoadOrderItemDetailsWithoutLoadProgressing(FromDate, ToDate);
                    setUniqueCrNumbers([]);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => { callError('error', error.message, 'Error'); });

    };

    const reamCalculation = (lineItems) => {
        let sheets = lineItems[0].no_of_sheets;

        // Summing the no_of_sheets using reduce
        //let totalSheets = lineItems.reduce((acc, item) => acc + item.no_of_sheets, 0);

        setSelectedLineItemDetail(lineItems);
        setSheeterNoOfSheets(sheets);
    };

    // const filteredReelData = reelList.filter((row) => {
    //     // Check if row matches selected status
    //     if (selectedStatus === 'All' || row.status === selectedStatus) {
    //         // Check if all filter fields match
    //         return Object.keys(filters).every((key) => {
    //             if (filters[key] === '') return true; // No filter applied
    //             return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
    //         });
    //     }
    //     return false;
    // });


    const selectableRows = reelList.filter(row => row.status !== 'converted');
    const allSelected = selectedRows.length === selectableRows.length && selectableRows.length > 0;
    const someSelected = selectedRows.length > 0 && selectedRows.length < selectableRows.length;

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // Select all selectable rows (exclude 'converted')
            let newSelectedRows;


            if (cr_number.length <= 0 || cr_number === undefined) {
                newSelectedRows = selectableRows.map(row => row.id_ream);
            }
            else {
                const filteredRows = selectableRows.filter(
                    (row) => row.cr_number === cr_number[0]
                );
                newSelectedRows = filteredRows.map(row => row.id_ream);

            }

            totalSheetsAndReam(newSelectedRows);
            setSelectedRows(newSelectedRows);
            return;
        }
        // Clear selection on uncheck
        setSelectedRows([]);
    };

    // const handleSelectAllClick = (event) => {
    //     if (event.target.checked) {
    //         // Select all selectable rows (exclude 'converted')
    //         const newSelectedRows = selectableRows.map(row => row.id_ream);
    //         totalSheetsAndReam(newSelectedRows);
    //         setSelectedRows(newSelectedRows); 
    //         return;
    //     }
    //     // Clear selection on uncheck
    //     setSelectedRows([]);
    // };


    // const handleSelectAllClick = (event) => {
    //     if (event.target.checked) {
    //         // const newSelectedRows = reelList.map((row) => row.id_ream);

    //         // Exclude rows with status 'converted'
    //         const newSelectedRows = reelList
    //             .filter((row) => row.status !== 'converted') // Exclude 'converted' rows
    //             .map((row) => row.id_ream);


    //         totalSheetsAndReam(newSelectedRows);
    //         setSelectedRows(newSelectedRows);
    //         return;
    //     }
    //     setSelectedRows([]);
    // };



    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        totalSheetsAndReam(newSelectedRows);
        setSelectedRows(newSelectedRows);

    };

    const handleRowClick = (event, id, status) => {
        if (status === 'converted') return;
        handleRowCheckboxClick(event, id);
    };


    const [checkedReams, setCheckedReams] = useState([]);

    const totalSheetsAndReam = (newSelectedRows) => {
        let selectedLines = [];
        let maxlimitSheets = 1000;
        if (jobID === 0) {
            selectedLines = reelList.filter((f) => newSelectedRows.includes(f.id_ream));

        }
        else {
            selectedLines = newSelectedRows;
            maxlimitSheets = sheeterNoOfSheets;
        }

        setCheckedReams(selectedLines);
        let totalReams = selectedLines.length;  //selectedLines.reduce((acc, item) => acc + item.number_of_sheets, 0); 

        if (maxlimitSheets > 0) {

            let bundleWeight = 0;

            // calculate number of bundles

            let total_bundle_weight = 0;
            let total_bundles = 0;
            let ream_count_in_bundle = 0;
            let ream_per_bundle = 0;
            let max_ream_count_identified = false;
            let max_reamCount_val = 0;
            let total_sheets_in_ream_pallet = 0;


            selectedLines.forEach(ream => {

                total_bundle_weight += ream.ream_weight;
                ream_count_in_bundle += 1;
                total_sheets_in_ream_pallet += ream.number_of_sheets;

                if (max_ream_count_identified === false) {
                    if (total_sheets_in_ream_pallet > maxlimitSheets) {

                        total_bundles = total_bundles + 1;
                        ream_per_bundle = ream_count_in_bundle - 1;
                        max_reamCount_val = ream_per_bundle;

                        //  bundle weight calculation
                        bundleWeight = total_bundle_weight - ream.ream_weight;

                        total_bundle_weight = ream.ream_weight;
                        total_sheets_in_ream_pallet = ream.number_of_sheets;
                        ream_count_in_bundle = 1;

                        max_ream_count_identified = true;

                        //update hdr details
                        let bWt = parseFloat(bundleWeight.toFixed(2))
                        addBundleDetails(total_bundles, bWt, ream_per_bundle, false);

                        addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                    }
                    else {
                        addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                    }
                }
                else {
                    if (total_sheets_in_ream_pallet > maxlimitSheets || ream_count_in_bundle > max_reamCount_val) {

                        total_bundles = total_bundles + 1;
                        ream_per_bundle = ream_count_in_bundle - 1;

                        //  bundle weight calculation
                        bundleWeight = total_bundle_weight - ream.ream_weight;
                        total_bundle_weight = ream.ream_weight;
                        total_sheets_in_ream_pallet = ream.number_of_sheets;
                        ream_count_in_bundle = 1;

                        //update hdr details
                        let bWt = parseFloat(bundleWeight.toFixed(2))
                        addBundleDetails(total_bundles, bWt, ream_per_bundle, false);

                        addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                    }
                    else {
                        addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                    }
                }


            });


            // lose bundle calculation
            let lbundle = 0;
            let lbundleWeight = 0;

            if (total_sheets_in_ream_pallet > 0 || ream_count_in_bundle > 0) {

                if (total_sheets_in_ream_pallet === maxlimitSheets) {
                    total_bundles += 1;
                    bundleWeight = total_bundle_weight;
                    addBundleDetails(total_bundles, bundleWeight, ream_count_in_bundle, false);
                }
                else {
                    lbundle = 1;
                    lbundleWeight = parseFloat(total_bundle_weight.toFixed(2));
                    setlossReams(1);
                    setLReamWeight(lbundleWeight);

                    //update hdr details
                    let l_bundle_number = total_bundles + 1;
                    let bWt = parseFloat(lbundleWeight.toFixed(2))
                    addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, true);
                }
            }

            // bundle-weight     
            setReamWeight(parseFloat(bundleWeight.toFixed(2)));
            setTotalReams(total_bundles + lbundle);
            setNumberOfReams(total_bundles);
            setNumberOfSheets(totalReams);
            setSheeterNoOfSheets(maxlimitSheets);
        }
    };

    const addBundleDetails = (bundleNumber, bundleWeight, numberOfReams, bundleStatus) => {
        const newBundle = {
            bundle_number: bundleNumber,
            bundle_weight: bundleWeight,
            number_of_reams: numberOfReams,
            bundle_status: bundleStatus
        };

        setBundleDetails(prevBundles => [...prevBundles, newBundle]);

    }

    const addReamList = (bundleNumber, reamid, reamnumber) => {
        const newBundle = {
            bundle_number: bundleNumber,
            reamid: reamid,
            reamnumber: reamnumber
        };

        setBundleWiseReam(prevBundles => [...prevBundles, newBundle]);

    }




    useEffect(() => {

        if (sheeterNoOfSheets > 0) {

            //setSheeterMsgOpen(false);

            let totalReams = checkedReams.length;
            let bundleWeight = 0;
            setBundleDetails([]);
            setBundleWiseReam([]);

            // calculate number of bundles
            let total_bundle_weight = 0;
            let total_bundles = 0;
            let ream_count_in_bundle = 0;
            let ream_per_bundle = 0;
            let total_sheets_in_ream_pallet = 0;
            let maximumlimit = parseInt(sheeterNoOfSheets);

            checkedReams.forEach(ream => {

                total_bundle_weight += ream.ream_weight;
                ream_count_in_bundle += 1;
                total_sheets_in_ream_pallet += ream.number_of_sheets;

                //total_bundle_weight > maxWightBundle ||
                if (total_sheets_in_ream_pallet > maximumlimit) {
                    total_bundles = total_bundles + 1;
                    ream_per_bundle = ream_count_in_bundle - 1;

                    //  bundle weight calculation
                    bundleWeight = total_bundle_weight - ream.ream_weight;

                    total_bundle_weight = ream.ream_weight;
                    ream_count_in_bundle = 1;
                    total_sheets_in_ream_pallet = ream.number_of_sheets;

                    //update hdr details
                    let bWt = parseFloat(bundleWeight.toFixed(2))
                    addBundleDetails(total_bundles, bWt, ream_per_bundle, false);
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);

                }
                else {
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                }

            });

            // lose bundle calculation
            let lbundle = 0;
            let lbundleWeight = 0;

            if (total_bundle_weight > 0 || ream_count_in_bundle > 0) {


                if (total_sheets_in_ream_pallet === maximumlimit) {
                    total_bundles += 1;
                    bundleWeight = total_bundle_weight;
                    let l_bundle_number = total_bundles;
                    let bWt = parseFloat(bundleWeight.toFixed(2))
                    addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, false);

                    setlossReams(0);
                    setLReamWeight(0);
                }
                else {
                    lbundle = 1;
                    lbundleWeight = parseFloat(total_bundle_weight.toFixed(2));
                    setlossReams(1);
                    setLReamWeight(lbundleWeight);

                    //update hdr details
                    let l_bundle_number = total_bundles + 1;
                    let bWt = parseFloat(lbundleWeight.toFixed(2))
                    addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, true);
                }
            }

            // bundle-weight     
            setReamWeight(parseFloat(bundleWeight.toFixed(2)));
            setTotalReams(total_bundles + lbundle);
            setNumberOfReams(total_bundles);
            setNumberOfSheets(totalReams);

            // if (sheeterNoOfSheets > ream_per_bundle) {
            //     callError('info', `We cannot set ${sheeterNoOfSheets} per bundle because the maximum weight limit is ${maxWightBundle}.`, 'info');
            //     setSheeterNoOfSheets(ream_per_bundle);
            // }

        }
        else {
            setTotalReams(0);
        }

    }, [sheeterNoOfSheets][setSheeterNoOfSheets]);


    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    // pallet list
    const handleSelectAllClickPallet = (event) => {
        if (event.target.checked) {
            const newSelectedRows = reamList.map((row) => row.id_ream_pallet_val);
            setSelectedReamRows(newSelectedRows);
            return;
        }
        setSelectedReamRows([]);
    };

    const handleRowCheckboxClickPallet = (event, rowId) => {
        const selectedIndex = selectedReamRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedReamRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedReamRows.slice(1);
        } else if (selectedIndex === selectedReamRows.length - 1) {
            newSelectedRows = selectedReamRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedReamRows.slice(0, selectedIndex),
                ...selectedReamRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedReamRows(newSelectedRows);

    };

    const isSelectedReam = (rowId) => selectedReamRows.indexOf(rowId) !== -1;

    const [selectedChip, setSelectedChip] = useState('Combinations');




    const LoadSelectedLineItemList = () => {

        setSelectedChip('View Sheeter Process');
        const selectedReels = reelList.filter((reels) => selectedRows.includes(reels.id_ream));
        if (selectedReels.length > 0) {
            setSelectedReelList(selectedReels);
            setviewReamProcess(true);
            setviewPalletList(false);

        }

    }
    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                        setWinderShiftCode(data[0]);
                        setWinderShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    const handleWinderShiftChange = (event, value) => {
        setWinderShiftCode(value);
        setWinderShiftID(value.shiftid);
    }



    useEffect(() => {
        if (!isOperatorDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperator(data);
                        setSelectedOperator(data[0]);
                        setSelectedOperatorName(data[0].operator_code);
                        setWinderOperators(data[0].operator_code);
                        setOperatorID(data[0].id);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isOperatorDataLoaded]);


    const handleOperatorChange = (event, value) => {
        setSelectedOperator(value);
        setSelectedOperatorName(value.operator_code);
        setWinderOperators(value.operator_code);
        setOperatorID(value.id);
    }


    const viewQRCode = async () => {
        const palletDetails1 = approvedPalletNumber.filter((ream) => selectedReamRows.includes(ream.id));
        const palletDetails = reamList.filter((ream) => selectedReamRows.includes(ream.id_ream_pallet_val));
        setSelectedReamDetails(palletDetails);
        setSelectedReamDetailsQR(palletDetails1);
        setViewReamQRCode(true);
    };

    const handlecallEditJob = (jobID) => {
        if (!hasPermission(userPermissions, "Ream Pallet", "View")) {
            alert("Access denied. You don’t have permission to view this page.");
            return; // Exit the function if permission is not granted
        }
        setJobID(jobID);

        setviewReamProcess(true);
        setviewPalletList(false);
        setViewLineItemList(false);

        setSelectedChip('View Sheeter Process');
        setViewJob(false);
        setNewJob(true);
    }

    // get job header details
    const [jobHDRDetails, setJobHDRDetails] = useState([]);
    const [updateshiftCode, setUpdateShiftCode] = useState('');
    const [updateOperator, setUpdateOperator] = useState('');
    const [shiftCodeUpdate, setShiftCodeUpdate] = useState(false);
    const [operatorUpdate, setOperatorUpdate] = useState(false);

    // useEffect(() => {
    //     if (jobID > 0) {

    //         const orderData = {
    //             p_companyid: localStorage.getItem('companyid'),
    //             p_plantid: 1,
    //             p_job_number: jobID

    //         };
    //         callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_PALLET_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
    //             .then(data => {
    //                 if (data && data.length > 0) {
    //                     const [firstJob] = data;
    //                     setJobHDRDetails(data);
    //                     setSheeterNoOfSheets(data[0].no_of_sheets);
    //                     //calculatePallets(data[0].no_of_sheets);

    //                     setUpdateShiftCode(firstJob.shift_code);
    //                     setShiftCodeUpdate(false);
    //                     setUpdateOperator(firstJob.s_operator);
    //                     setOperatorUpdate(false);
    //                     setFNo(firstJob.fno);
    //                     setWinderShiftDate(dayjs(firstJob.shift_date));                        

    //                 } else {
    //                     // No data found
    //                     setJobHDRDetails([]);
    //                     callError('info', 'No MO are released this date range, Kindly adjust data range.', 'info');
    //                 }
    //             })
    //             .catch(error => { callError('error', error.message, 'Error'); });
    //     }

    // }, [jobID]);


    useEffect(() => {
        if (jobID > 0) {
            (async () => {
                try {
                    const orderData = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_plantid: 1,
                        p_job_number: jobID
                    };

                    const data = await callApi(
                        API_ENDPOINTS.PROD_MANAGEMENT_REAM_PALLET_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID,
                        'POST',
                        { 'Content-Type': 'application/json' },
                        orderData
                    );

                    if (data && data.length > 0) {
                        const [firstJob] = data;
                        setJobHDRDetails(data);
                        setSheeterNoOfSheets(firstJob.no_of_sheets);
                        // calculatePallets(firstJob.no_of_sheets);

                        setUpdateShiftCode(firstJob.shift_code);
                        setShiftCodeUpdate(false);
                        setUpdateOperator(firstJob.s_operator);
                        setOperatorUpdate(false);
                        setFNo(firstJob.fno);
                        setWinderShiftDate(dayjs(firstJob.shift_date));

                        const orderData1 = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_bundle_number: '',
                            p_mode: 1,
                            p_pallet_id: jobID
                        };

                        const data1 = await callApi(
                            API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_PALLET_DETAIL_NEW,
                            'POST',
                            { 'Content-Type': 'application/json' },
                            orderData1
                        );

                        setReamPalletListLoading(true);
                        if (data1 && data1.length > 0) {
                            setReamList(data1);
                            setViewReamQRCode(true);
                            setViewJob(false);
                            setReamPalletListLoading(false);
                        }
                    } else {
                        setJobHDRDetails([]);
                        callError('info', 'No MO are released this date range, Kindly adjust data range.', 'info');
                    }
                } catch (error) {
                    callError('error', error.message, 'Error');
                    setReamPalletListLoading(false);
                }
            })();
        }
    }, [jobID]);

    // i have hide code for testing
    useEffect(() => {
        if (jobID > 0) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'), p_plantid: 1, p_job_number: jobID
            };


            callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_PALLET_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_REAM_LIST_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {

                        setSelectedReelList(data);
                        totalSheetsAndReam(data);

                        const parameter = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_plantid: 1,
                            p_indent_no: data[0].indent_no,
                            p_lineno: data[0].line_no

                        };

                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SELECTED_ORDER_LINE_ITEMS_DETAILS_REAMPALLET, 'POST', { 'Content-Type': 'application/json' }, parameter)
                            .then(LineItemData => {
                                if (LineItemData && LineItemData.length > 0) {
                                    setSelectedLineItemDetail(LineItemData);
                                }
                            })
                            .catch(error => { callError('error', error.message, 'Error'); });

                    } else {
                        // No data found
                        setSelectedReelList([]);
                        callError('info', 'No MO are released this date range, Kindly adjust data range.', 'info');
                    }
                })
                .catch(error => { callError('error', error.message, 'Error'); });
        }

    }, [jobID]);


    // reel list 14-10-2025 thiravidam
    // useEffect(() => {
    //     if (jobID > 0) {

    //         const orderData = {
    //             p_companyid: localStorage.getItem('companyid'),
    //             p_bundle_number: '',
    //             p_mode: 1,
    //             p_pallet_id: jobID
    //         };

    //         callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_PALLET_DETAIL_NEW, 'POST', { 'Content-Type': 'application/json' }, orderData)
    //             .then(data => {
    //                 if (data && data.length > 0) {
    //                     setReamList(data);
    //                     setViewReamQRCode(true);
    //                 }
    //             })
    //             .catch(error => {
    //                 alert(error.message);
    //             });

    //     }
    // }, [jobID]);

    useEffect(() => {
        if (shiftCodeUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setShiftCodes(data);
                    const selectedShift = data.find(shift => shift.shiftid === updateshiftCode);
                    if (selectedShift) {
                        setWinderShiftCode(selectedShift);
                        setWinderShiftID(selectedShift.shiftid);
                    }
                }
                setShiftCodeUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateshiftCode, shiftCodeUpdate]);

    useEffect(() => {
        if (operatorUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid'), p_plantid: 1 };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setOperator(data);
                    const selectedOperator = data.find(operator => operator.operator_code === updateOperator);
                    if (selectedOperator) {
                        setSelectedOperator(selectedOperator);
                        setSelectedOperatorName(selectedOperator.operator_code);
                        setWinderOperators(selectedOperator.operator_code);
                    }
                }
                setOperatorUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateOperator, operatorUpdate]);



    const convertInputDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${month}/${day}/${year}`;
    };

    const convertDataDate = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${month}/${day}/${year}`;
    };

    const summaryData = summaryList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied

                if (key === 'from_date' || key === 'to_date') {
                    // Convert row date to Date object
                    const rowDate = new Date(convertDataDate(row.date));
                    const fromDate = filters.from_date ? new Date(convertInputDate(filters.from_date)) : null;
                    const toDate = filters.to_date ? new Date(convertInputDate(filters.to_date)) : null;

                    // Check if row date is within the range
                    if (fromDate && toDate) {
                        return rowDate >= fromDate && rowDate <= toDate;
                    } else if (fromDate) {
                        return rowDate >= fromDate;
                    } else if (toDate) {
                        return rowDate <= toDate;
                    }
                    return true;
                }

                // Default string comparison for other filters
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    // sorting process
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortColumn, setSortColumn] = useState('date'); // Default sort by 'date'


    const handleSort = (column) => {
        const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newDirection);
        setSortColumn(column);
    };

    const sortedData = useMemo(() => {
        return [...summaryData].sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    }, [summaryData, sortColumn, sortDirection]);

    const handleSubMenuButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedChip(buttonName);

        if (buttonName === 'View Reel List') {
            setViewLineItemList(false);
            setviewPalletList(true);
            setviewReamProcess(false);
        }
        else if (buttonName === 'View Sheeter Process') {
            setviewSheeterchildRollDetail(true);
            setviewPalletList(false);
        }
        else if (buttonName === 'Line Item Wise Achieved Reels') {
            setViewLineItemList(true);
            setviewPalletList(false);
        }
        else if (buttonName === 'View Summary') {

            setViewJob(true);
            setNewJob(false);
            setJobID(0);
        }
    };


    // insert bundle details:

    const InsertBundleDetails = async () => {


        if (fNo === 0) {
            callError('warning', 'Please set F.No.', 'Warning');
            return;
        }

        const parameter = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_ream_detail: bundleWiseReam,
            p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
            p_shift_id: winderShiftID,
            p_user_id: operatorID,
            p_bundle_weight: reamWeignt,
            p_l_bundle_weight: lReamWeignt,
            p_reams_bundle: sheeterNoOfSheets,
            p_total_bundle: totalReams,
            p_l_bundle: lossReams,
            p_max_bundle_weight: maxWightBundle,
            p_user: localStorage.getItem('userID'),
            p_bundle_detail: bundleDetails,
            p_fno: fNo,
        }




        await callApi(API_ENDPOINTS.PROD_MANAGEMENT_CREATE_REAM_PALLET_USING_MULTIPLE_REAM, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    setApprovedPalletNumber(data);

                    callError('info', 'Ream Pallet Number Created Successfully.', 'info');

                    alert("Ream Pallet Number Created Successfully.")

                    setViewReamsList(true);
                    setDisableSaveBtn(true);
                    setDisbleSheetValue(true);
                    setPalletStatus('Completed')

                    let id_ream_hdr = data[0].id_hdr;
                    handleLoadReamPalletList(id_ream_hdr);

                }
            })
            .catch(error => {
                alert(error.message);
            });
    };


    const handleLoadReamPalletList = async (id_ream_hdr) => {

        const reamFilter = {
            p_companyid: localStorage.getItem('companyid'),
            p_bundle_number: '',
            p_mode: 1,
            p_pallet_id: id_ream_hdr
        };
        setReamPalletListLoading(true);

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_PALLET_DETAIL_NEW, 'POST', { 'Content-Type': 'application/json' }, reamFilter)
            .then(reamdata => {
                if (reamdata && reamdata.length > 0) {
                    setReamList(reamdata);
                    setViewReamQRCode(true);
                    setReamPalletListLoading(false);
                }
            })
            .catch(error => {
                alert(error.message);
                setReamPalletListLoading(false);
            });
    }


    const LoadProducedReamPalletList = () => {
        if (jobID > 0) {
            setViewLineItemList(false);

            const reamFilter = {
                p_companyid: localStorage.getItem('companyid'),
                p_bundle_number: '',
                p_mode: 1,
                p_pallet_id: jobID
            };
            setReamPalletListLoading(true);

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_PALLET_DETAIL_NEW, 'POST', { 'Content-Type': 'application/json' }, reamFilter)
                .then(reamdata => {
                    if (reamdata && reamdata.length > 0) {
                        setReamList(reamdata);
                        setViewReamQRCode(true);
                        setReamPalletListLoading(false); 
                    }
                })
                .catch(error => {
                    alert(error.message);
                    setReamPalletListLoading(false);
                });
        }
    }


    const handleQuantityChange = (index, quantity) => {
        setReamList((prevRows) => {
            return prevRows.map((row, i) => {
                if (i === index) {
                    return { ...row, ream_pallet_gross_weight: quantity }; // Create a new object for state change detection
                }
                return row;
            });
        });
    };

    const handleUpdateGrossWeight = () => {
        const payload = {
            p_companyid: localStorage.getItem('companyid'),
            p_plant_id: 1,
            p_ream_pallet_list: reamList,
        }
        processIndent(payload);
    }

    useEffect(() => {
        if (updateApproveList?.length > 0) {
            setApprovedPalletNumber(updateApproveList);

            let id_ream_hdr = updateApproveList[0].id_hdr;
            handleLoadReamPalletList(id_ream_hdr);
        }
    }, [updateApproveList, setApprovedPalletNumber]);



    // filter oprations 
    const columns = ['job_number', 'shift_code', 'shift_date', 'indent_no', 'cr_number', 'ream_pallet_list', 's_operator', 'bundle_count',];
    const autoCompleteColumns = ['job_number', 'shift_code', 'shift_date', 's_operator', 'indent_no',];
    // , 'status', 'indent_no', 'cr_number',
    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const uniqueValues = {
        job_number: [...new Set(summaryList.map(row => row.job_number))],
        shift_code: [...new Set(summaryList.map(row => row.shift_code))],
        shift_date: [...new Set(summaryList.map(row => row.shift_date))],
        indent_no: [...new Set(summaryList.map(row => row.indent_no))],
        cr_number: [...new Set(summaryList.map(row => row.cr_number))],
        ream_pallet_list: [...new Set(summaryList.map(row => row.ream_pallet_list))],
        s_operator: [...new Set(summaryList.map(row => row.s_operator))],
        bundle_count: [...new Set(summaryList.map(row => row.bundle_count))],
        status: [...new Set(summaryList.map(row => row.status))],

    };

    //Delete Ream-Pallet Job
    const DeleteReamPalletProductionJobDetails = () => {
        if (!hasPermission(userPermissions, "Ream Pallet", "Delete")) {
            callError("error", "Access denied. You don’t have permission to delete this job.", "Error");
            return;
        }

        const confirmDelete = window.confirm(`Are you sure you want to delete the entire job ${jobID}?`);
        if (confirmDelete) {
            if (jobID === 0) {
                callError('warning', 'Please select the Job Details to delete.', 'Warning');
                return;
            }

            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_pallet_id: jobID,
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_DeleteReamPalletJobDetails, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        if (data[0].status === 'success') {
                            LoadJobList();
                            setSelectedChip('');
                            setViewJob(true);
                            setNewJob(false);

                            alert('Ream Pallet Job Deleted successfully.')
                        }
                    } else {
                        callError('warning', 'Unable to delete the job.', 'Warning');
                    }
                })
                .catch(error => {
                    callError('error', error.message, 'Error');
                });
        }
    };

      const AlertMessage = (severity, message, title, open) => {
        setSheeterSeverityvalue(severity);
        setSheeterMessageValue(message);
        setSheeterAlertTitleValue(title);
        setSheeterMsgOpen(open);
    };

    //Delete Selected Ream-Pallets in Job
    const DeleteSelectedReamPalletsProductionJobDetails = () => {
            if (!hasPermission(userPermissions, "Ream Pallet", "Delete")) {
                alert("Access denied. You don’t have permission to delete the Ream Pallets.");
                return; // Exit the function if permission is not granted
            }
            let printselectedReamDetails = reamList;  
            printselectedReamDetails = reamList.filter((ream) => selectedReamRows.includes(ream.id_ream_pallet_val));
    
            if (jobID === 0) {
                AlertMessage('warning', 'Please select the Job Details to delete.', 'Warning', true);
                return;
            }
    
            if (printselectedReamDetails.length === 0) {
                AlertMessage('warning', 'Please select at least one ream pallet code to delete', 'Warning', true);
                return;
            }
    
            if (reamList.length === printselectedReamDetails.length) {
                AlertMessage('warning', 'Cannot delete all ream pallets in a Job. Please delete the entire job.', 'Warning', true);
                return;
            }
    
            const confirmDelete = window.confirm(`Are you sure you want to delete the selected ream pallets in this job details?`);
    
            if (confirmDelete) {
                setSheeterMsgOpen(false);
    
                const parameter = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_plant_id: 1,
                    p_selected_reams: printselectedReamDetails,
                };
    
                // create reams                   
                callApi(API_ENDPOINTS.PROD_MANAGEMENT_DeleteSelectedReamPalletsInJob, 'POST', { 'Content-Type': 'application/json' }, parameter)
                    .then(data => {
                        if (data && data.length > 0) {
                            if (data === 'Selected ream pallets are deleted successfully.') {
    
                                LoadJobList();
                                LoadProducedReamPalletList();   
    
    
                                AlertMessage('success', data, 'Success', true);
                            }
                            else {
                                AlertMessage('warning', data, 'Warning', true);
                            }
                        }
                        else {
                            AlertMessage('error', 'Unable to delete the Selected Ream Pallets In Job.', 'Error', true);
                        }
                    })
                    .catch(error => {
                        AlertMessage('error', error.message, 'Error', true);
                    });
            }
        }


    // Calculate the number of pages
    const pageCount = Math.ceil(summaryList.length / recordsPerPage);

    // Get the records for the current page
    const currentRecords = sortedData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );



    return (
        <Box>

            {viewJob && (
                <>
                    <Divider />

                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            {/* First Menu */}
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirst}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}

                            >
                                <MenuItem onClick={() => handleMenuItemClickFirst('All Ream Pallet Punching')}>Ream Pallet Puching Summary</MenuItem>
                            </Menu>

                            {/* Adding margin-left: auto to push the button to the right */}
                            <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                            {/* Second Menu */}
                            <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                            <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Child rolls" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Child rolls" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu>



                            <div>
                                <IconButton onClick={handleBackWinderMachineEntry} >
                                    <Close sx={{ fontSize: "18px", color: "#2196F3" }} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>

                    <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >
                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px">
                            <FormControl fullWidth size="small">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        style={{ marginLeft: '10px' }}
                                        id="FromDate"
                                        value={dayjs(FromShiftDate)}
                                        onChange={(date) => handleFromShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                        autoFocus
                                        format="DD-MMM-YYYY"
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item mt="5px" ml="10px" mr="10px">
                            <Typography fontWeight="bold">-</Typography>
                        </Grid>


                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px" mr="10px">
                            <FormControl fullWidth size="small" >
                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                    <DatePicker
                                        id="ToDate"
                                        value={dayjs(ToShiftDate)}
                                        format="DD-MMM-YYYY"
                                        onChange={(date) => handleToShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>


                    </Grid>
                    <Divider sx={{ marginTop: "5px" }} />

                    <ResponsiveBox colors={colors} customMaxHeight={{
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '82vh', // Large devices (desktops)
                        xl: '86vh', // Extra large devices (large desktops)
                    }}>

                        <CustomTableContainer colors={colors}>
                            <TableContainer >
                                {loading ? (
                                    <SkeletonTableLoader rows={5} columns={11} />
                                ) : (
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                            <TableRow>
                                                <TableCell onClick={() => handleSort('job_number')}>
                                                    JOB NUMBER {sortColumn === 'job_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('shift_code')}>
                                                    SHIFT {sortColumn === 'shift_code' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('shift_date')}>
                                                    SHIFT DATE {sortColumn === 'shift_date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell sx={{ minWidth: 100, whiteSpace: "nowrap" }} onClick={() => handleSort('indent_no')}>
                                                    CO NUMBER  {sortColumn === 'indent_no' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('cr_number')}>
                                                    CHILD REEL NUMBER  {sortColumn === 'cr_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>


                                                <TableCell onClick={() => handleSort('ream_pallet_list')}>
                                                    REAM PALLET NO  {sortColumn === 'ream_pallet_list' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('s_operator')}>
                                                    OPERATOR {sortColumn === 's_operator' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('pallet_count')}>
                                                    TOTAL BUNDLES {sortColumn === 'pallet_count' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>


                                            </TableRow>
                                            <TableFilterRow
                                                columns={columns}
                                                filters={filters}
                                                handleFilterChange={handleFilterChangeTable}
                                                uniqueValues={uniqueValues}
                                                autoCompleteColumns={autoCompleteColumns}
                                            />
                                        </TableHead>
                                        <TableBody>
                                            {currentRecords.map((row, index) => (
                                                <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                                    <TableCell> <span
                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                        onClick={() => handlecallEditJob(row.job_number)}
                                                    >
                                                        JOB# {row.job_number}
                                                    </span></TableCell>
                                                    <TableCell>{row.shift_code}</TableCell>
                                                    <TableCell>{row.shift_date}</TableCell>
                                                    <TableCell>{row.indent_no}</TableCell>
                                                    <TableCell>{row.cr_number}</TableCell>
                                                    <TableCell>{row.ream_pallet_list}</TableCell>
                                                    <TableCell>{row.s_operator}</TableCell>

                                                    <TableCell sx={{ textAlign: 'right' }}>{`${row.bundle_count} `}</TableCell>
                                                    {/* <TableCell>{row.status}</TableCell> */}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}

                                <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                                    <Pagination
                                        count={pageCount}
                                        page={currentPage}
                                        onChange={(event, value) => setCurrentPage(value)}

                                    />
                                </Box>
                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox>


                </>
            )}


            {newJob && (



                <>
                    <Header title={t('prod_menu.reampalletpunching')} subtitle="" callback={callback} />
                    <Dialog
                        open={open}
                        onClose={closepopup}
                        fullWidth
                        maxWidth="xs"

                    >
                        <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
                            <QualityCheckRejectProcee rejectReelType={'REAM'} rejectReason={rejectReason} setRejectReason={setRejectReason} selectedReason={selectedReason} setSelectedReason={setSelectedReason} rejectProductType={rejectProductType} setRejectProductType={setRejectProductType} rejectStatus={rejectStatus} setRejectStatus={setRejectStatus} rejectReasonID={rejectReasonID} setRejectReasonID={setRejectReasonID} rejectRemarks={rejectRemarks} setRejectRemarks={setRejectRemarks} enableReject={enableReject} setEnableReject={setEnableReject} />
                        </DialogContent>
                        <DialogActions sx={{ backgroundColor: theme.palette.background.default }}>
                            <Button onClick={closepopup} variant="contained">
                                Update
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Divider />



                    <Grid container display="flex-start" padding={0.5}>
                        {viewPalletList && (
                            <>
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="Back to Line item wise achieved reams ">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('Line Item Wise Achieved Reels')}  >
                                                <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'Line Item Wise Achieved Reels' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Line Item Wise Achieved Reams</Typography>
                                            </IconButton>
                                            {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="View available ream list for production">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                <CheckCircleOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Ream List</Typography>
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                            </>
                        )}


                        {viewReamProcess && (
                            <>
                                {jobID === 0 && (
                                    <>
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to View ream list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Ream List</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert reams to bundle process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Ream Pallet Punching Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                    </>
                                )}
                                {jobID > 0 && (
                                    <>

                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to Summary list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Summary')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Summary' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Summary</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert reams to bundle process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Ream Pallet Punching Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    </>
                                )}
                            </>
                        )}
                    </Grid>



                    {viewLineItemList === false && (
                        <Divider />
                    )}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={sheeterMsgOpen} setParentRollMsgOpen={setSheeterMsgOpen} parentRollSeverityvalue={sheeterSeverityvalue}
                        setParentRollSeverityvalue={setSheeterSeverityvalue} parentRollAlertTitleValue={sheeterAlertTitleValue}
                        setParentRollAlertTitleValue={setSheeterAlertTitleValue} parentRollMessageValue={sheeterMessageValue} setParentRollMessageValue={setSheeterMessageValue} />




                    <Box
                        sx={{
                            // backgroundColor: colors.primary[700],
                            padding: "10px",
                            borderRadius: "10px",
                            // marginTop: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '76vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>
                        <>
                            {(viewPalletList === false && viewReamProcess === false) && (
                                <>
                                    <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                        <Grid container padding="0px 0px 1px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                            <Grid item xs={12} sm={12} md={1.6} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6"> {t('prod_paper_machine.filter_by')} </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={11} md={3.8} lg={1.75} xl={1.75}>
                                                <FormControl fullWidth size="small">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            style={{ marginLeft: '10px' }}
                                                            id="FromDate"
                                                            value={dayjs(FromDate)}
                                                            onChange={(date) => handleDateChange2(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                            autoFocus
                                                            format="DD-MMM-YYYY" // Use the appropriate format string
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={1.75} xl={1.75}>
                                                <FormControl fullWidth size="small" >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                        <DatePicker
                                                            id="ToDate"
                                                            value={dayjs(ToDate)}
                                                            format="DD-MMM-YYYY"
                                                            onChange={(date) => handleDateChange1(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.6} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6">CO Number</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={1.8} xl={2}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={filterIndentno}
                                                    onChange={handleIndentNoChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={indentNoList}
                                                    getOptionLabel={(option) => (option?.indent_no ? `${option.indent_no}` : '')} // Safely handle undefined
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            {...params} variant="outlined" />}
                                                />
                                            </Grid>

                                        </Grid>
                                    </Grid>


                                    <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </>
                            )}

                            {viewLineItemList && (
                                <>
                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <CustomTableContainer colors={colors}>
                                                <TableContainer >

                                                    {loadingOrderItemDet ? (
                                                        <SkeletonTableLoader rows={5} columns={11} />
                                                    ) : (
                                                        <Table size="small">
                                                            <TableHead sx={{ height: 10 }}>
                                                                <TableRow>

                                                                    <TableCell sx={{ textAlign: "center" }}>CO DATE</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>CO NUMBER</TableCell>
                                                                    {/* <TableCell sx={{ textAlign: "center" }}>CUSTOMER NAME</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>SUPPLIER NAME</TableCell> */}
                                                                    <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>WIDTH</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>LENGTH</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>PRODUCED REAMS</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>ACH.QTY</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>PRODUCED QTY</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>TOTAL REAM PALLET</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>NO.OF.SHEETS IN REAM</TableCell>
                                                                    {/* <TableCell sx={{ textAlign: "center" }}>LINE NUMBER</TableCell> */}
                                                                    <TableCell>Action</TableCell>
                                                                    <TableCell>
                                                                        <IconButton >
                                                                            {/* onClick={handleOpen} */}
                                                                            <Searchicon style={{ fontSize: "16px" }} />
                                                                        </IconButton>
                                                                        <Modal
                                                                            // open={open}
                                                                            // onClose={handleClose}
                                                                            aria-labelledby="modal-modal-title"
                                                                            aria-describedby="modal-modal-description"
                                                                        >
                                                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                <TextField
                                                                                    label="Parent Roll Number"
                                                                                    name="name"
                                                                                    // value={filters.pr_number}
                                                                                    // onChange={handleFilterChange}
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                />
                                                                                <TextField
                                                                                    label="MA Number"
                                                                                    name="companyName"
                                                                                    // value={filters.release_no}
                                                                                    // onChange={handleFilterChange}
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                />

                                                                                <TextField
                                                                                    label="Status"
                                                                                    name="status"
                                                                                    // value={filters.status}
                                                                                    // onChange={handleFilterChange}
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                />


                                                                                <Button variant="contained" style={{ marginTop: 10 }}>
                                                                                    {/* onClick={handleClose}  */}
                                                                                    Apply Filter
                                                                                </Button>
                                                                            </Box>
                                                                        </Modal>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {filteredData.map((row) => (

                                                                    <>
                                                                        <React.Fragment key={row.indent_no}>

                                                                            <TableRow key={row.id}>

                                                                                <TableCell sx={{ textAlign: "center" }}>{row.indent_date}</TableCell>
                                                                                <TableCell sx={{ textAlign: "left", fontWeight: "bold" }}>
                                                                                    <span
                                                                                        style={{ color: '#039be5', textDecoration: 'underline', cursor: 'pointer' }}
                                                                                        onClick={() => handleCallEdit(row.indent_no, row.line_no)}
                                                                                    >
                                                                                        {row.indent_no}
                                                                                    </span>
                                                                                </TableCell>
                                                                                {/* <TableCell sx={{ textAlign: "left" }}>{row.customer_name}</TableCell>
                                                                                <TableCell sx={{ textAlign: "left" }}>{row.supplier_name}</TableCell> */}
                                                                                <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.d_width}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.d_length}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.reel_count}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.total_qty}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.plannedqty}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.bundle_count}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                                {/* <TableCell sx={{ textAlign: "center" }}>{row.line_no}</TableCell> */}
                                                                                <TableCell>
                                                                                    <Tooltip title="View child roll wise production">
                                                                                        <IconButton onClick={() => handleExpandRow(row)}>
                                                                                            {expandedRow === row.indent_no ? <ExpandLess style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} /> : <ExpandMore style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} />}
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </TableCell>
                                                                            </TableRow>


                                                                            {/* Expanded Row */}
                                                                            {expandedRow === row.indent_no && (
                                                                                <TableRow>
                                                                                    <TableCell colSpan={8}>
                                                                                        <Collapse in={expandedRow === row.indent_no} timeout="auto" unmountOnExit>
                                                                                            <Box margin={0}>
                                                                                                {/* Expanded Data in Table Format */}
                                                                                                {expandedData[row.indent_no] ? (
                                                                                                    <Table size="small" aria-label="expanded-data">
                                                                                                        <TableHead>
                                                                                                            <TableRow>
                                                                                                                <TableCell></TableCell>

                                                                                                                <TableCell sx={{ textAlign: "center" }}>CR NUMBER</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center" }}>TOTAL WEIGHT</TableCell>

                                                                                                            </TableRow>
                                                                                                        </TableHead>

                                                                                                        <TableBody>
                                                                                                            {(() => {
                                                                                                                // group data by cr_number + status
                                                                                                                const grouped = expandedData[row.indent_no].reduce((acc, item) => {
                                                                                                                    const key = `${item.cr_number}_${item.status}`;
                                                                                                                    if (!acc[key]) {
                                                                                                                        acc[key] = {
                                                                                                                            cr_number: item.cr_number,
                                                                                                                            status: item.status,
                                                                                                                            total_weight: 0,
                                                                                                                        };
                                                                                                                    }
                                                                                                                    acc[key].total_weight += Number(item.ream_weight || 0);
                                                                                                                    return acc;
                                                                                                                }, {});

                                                                                                                // convert to array for mapping
                                                                                                                const groupedArray = Object.values(grouped);

                                                                                                                return groupedArray.map((group, index) => (
                                                                                                                    <TableRow key={index}>
                                                                                                                        <TableCell>{index + 1}</TableCell>
                                                                                                                        <TableCell>{group.cr_number}</TableCell>

                                                                                                                        <TableCell sx={{ textAlign: 'right' }}>
                                                                                                                            {Number(group.total_weight || 0).toFixed(1)}
                                                                                                                        </TableCell>

                                                                                                                        {/* <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>{group.status}</TableCell> */}


                                                                                                                        <TableCell sx={{ textAlign: 'center' }}>
                                                                                                                            <Tooltip title="Child-Reel to Bundle Conversion Status">
                                                                                                                                <Box
                                                                                                                                    component="span"
                                                                                                                                    sx={{
                                                                                                                                        display: 'inline-block',
                                                                                                                                        px: 1.5,
                                                                                                                                        py: 0.4,
                                                                                                                                        borderRadius: '16px',
                                                                                                                                        bgcolor:
                                                                                                                                            group.status?.toLowerCase() === 'converted'
                                                                                                                                                ? '#00838f' // gray for converted
                                                                                                                                                : group.status?.toLowerCase() === 'approved'
                                                                                                                                                    ? '#388e3c' // green for approved
                                                                                                                                                    : group.status?.toLowerCase() === 'wip'
                                                                                                                                                        ? '#0288d1' // blue for work-in-progress
                                                                                                                                                        : '#f57c00', // orange for any other / unknown
                                                                                                                                        color: 'white',
                                                                                                                                        fontWeight: 500,
                                                                                                                                        fontSize: '0.8rem',
                                                                                                                                        textTransform: 'capitalize',
                                                                                                                                        textAlign: 'center',
                                                                                                                                        fontFamily: 'Roboto, sans-serif',
                                                                                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {group.status}
                                                                                                                                </Box>
                                                                                                                            </Tooltip>
                                                                                                                        </TableCell>

                                                                                                                    </TableRow>
                                                                                                                ));
                                                                                                            })()}
                                                                                                        </TableBody>
                                                                                                        {/* <TableBody>
                                                                                                            {expandedData[row.indent_no].map((item, index) => (
                                                                                                                <TableRow key={index}>
                                                                                                                    <TableCell>{index + 1}</TableCell>
                                                                                                                    <TableCell>{item.ream_code}</TableCell>
                                                                                                                    <TableCell>{item.cr_number}</TableCell>
                                                                                                                    <TableCell>{item.ream_weight}</TableCell>
                                                                                                                    <TableCell>{item.status}</TableCell>
                                                                                                                </TableRow>
                                                                                                            ))}
                                                                                                        </TableBody> */}
                                                                                                    </Table>
                                                                                                ) : (
                                                                                                    "Loading..."
                                                                                                )}
                                                                                            </Box>
                                                                                        </Collapse>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )}
                                                                        </React.Fragment>
                                                                    </>
                                                                ))}
                                                            </TableBody>
                                                        </Table>)}
                                                </TableContainer>
                                            </CustomTableContainer>
                                        </Grid>
                                    </Grid>
                                </>
                            )}

                            {/* view pallet list */}

                            {viewPalletList && (
                                <>
                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>



                                                <Autocomplete
                                                    fullWidth

                                                    multiple
                                                    size="small"
                                                    options={uniqueCrNumbers}  // Use the uniqueCrNumbers array
                                                    value={cr_number}
                                                    onChange={handleCRNumberChange}
                                                    getOptionLabel={(option) => option}  // Simply use the cr_number value
                                                    isOptionEqualToValue={(option, value) => option === value}  // Match cr_number directly
                                                    renderInput={(params) => (
                                                        <TextField color="secondary" {...params}
                                                            variant="outlined" placeholder="Filter by CR Number" />
                                                    )}
                                                />



                                            </Grid>

                                            <ResponsiveBox customMaxHeight={{
                                                xs: '72vh', // Extra small devices (phones)
                                                sm: '72vh', // Small devices (tablets)
                                                md: '60vh', // Medium devices (small laptops)
                                                lg: '64vh', // Large devices (desktops)
                                                xl: '73vh', // Extra large devices (large desktops)
                                            }}>
                                                <CustomTableContainer colors={colors}>

                                                    <TableContainer >
                                                        <Table size="small">
                                                            <TableHead sx={{ height: 10 }}>
                                                                <TableRow>
                                                                    <TableCell>

                                                                        <Checkbox
                                                                            sx={{
                                                                                '& .MuiSvgIcon-root': { fontSize: 22 },
                                                                                color: 'secondary'
                                                                            }}
                                                                            indeterminate={someSelected}
                                                                            checked={allSelected}
                                                                            onChange={handleSelectAllClick}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: "center" }}>REAM CODE</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>CR NUMBER</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>SHEET SIZE</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>



                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {filteredReelData.map((row) => (
                                                                    <TableRow key={row.id_ream} sx={{
                                                                        cursor: "pointer",
                                                                        opacity: 1
                                                                    }}

                                                                        onClick={(event) => handleRowClick(event, row.id_ream, row.status)}>
                                                                        <TableCell>
                                                                            <Checkbox
                                                                                size="small"
                                                                                sx={{
                                                                                    '& .MuiSvgIcon-root': { fontSize: 22 }, // Adjust the size of the checkbox icon
                                                                                    color: 'secondary' // Custom color
                                                                                }}
                                                                                checked={isSelected(row.id_ream)}
                                                                                disabled={row.status === 'converted'}
                                                                                onChange={(event) => handleRowCheckboxClick(event, row.id_ream)}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell sx={{ textAlign: "left" }}>{row.ream_code}</TableCell>
                                                                        <TableCell sx={{ textAlign: "left", width: "200px" }}>{row.cr_number}</TableCell>
                                                                        <TableCell sx={{ textAlign: "right" }}>{row.item_code}</TableCell>
                                                                        <TableCell sx={{ textAlign: "right" }}>{row.gsm}</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>{row.sheet_size}</TableCell>
                                                                        <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>

                                                                        <TableCell sx={{ textAlign: 'center' }}>
                                                                            <Tooltip title="Child-Reel to Ream Pallet Conversion Status">
                                                                                <Box
                                                                                    component="span"
                                                                                    sx={{
                                                                                        display: 'inline-block',
                                                                                        px: 2,
                                                                                        py: 0.4,
                                                                                        borderRadius: '16px',
                                                                                        bgcolor:
                                                                                            row.status?.toLowerCase() === 'converted'
                                                                                                ? '#00838f' // gray for converted
                                                                                                : row.status?.toLowerCase() === 'approved'
                                                                                                    ? '#388e3c' // green for approved
                                                                                                    : row.status?.toLowerCase() === 'wip'
                                                                                                        ? '#0288d1' // blue for work-in-progress
                                                                                                        : '#f57c00', // orange for any other / unknown
                                                                                        color: 'white',
                                                                                        fontWeight: 500,
                                                                                        fontSize: '0.8rem',
                                                                                        textTransform: 'capitalize',
                                                                                        textAlign: 'center',
                                                                                        fontFamily: 'Roboto, sans-serif',
                                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                                                                    }}
                                                                                >
                                                                                    {row.status}
                                                                                </Box>
                                                                            </Tooltip>
                                                                        </TableCell>

                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CustomTableContainer>
                                            </ResponsiveBox>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>



                                    <Box
                                        sx={{
                                            position: "fixed", // Keep the button fixed at the bottom
                                            bottom: 16, // Distance from the bottom of the viewport
                                            right: 25, // Distance from the right of the viewport
                                            zIndex: 1000, // Ensure it appears above other elements
                                        }}
                                    >


                                        <Button
                                            endIcon={
                                                <DoubleArrowRounded
                                                    className="arrow-icon"
                                                />
                                            }
                                            onClick={LoadSelectedLineItemList}
                                            sx={{
                                                textTransform: "none",
                                                borderRadius: 3,
                                                px: 2,
                                                py: 0.7,
                                                fontWeight: 600,
                                                fontSize: "0.8rem",
                                                letterSpacing: 0.3,
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor: (theme) => theme.palette.secondary.dark,
                                                    transform: "scale(1.03)",
                                                },
                                                "&:hover .arrow-icon": {
                                                    transform: "translateX(5px)",   // move the arrow slightly forward
                                                    transition: "transform 0.3s ease-in-out",
                                                },
                                            }}
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            disabled={selectedRows.length === 0}
                                        >
                                            Proceed to Next
                                        </Button>
                                    </Box>


                                </>
                            )}


                            {jobID > 0 && (
                                <Grid container padding="1px 10px 10px 25px" sx={{ backgroundColor: colors.primary[400] }} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            JOB Number
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                        <TextField size="small" value={jobID} />
                                    </Grid>
                                </Grid>
                            )}

                            {viewReamProcess && (
                                <>

                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                        <Grid mt={2} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                                            <Grid container padding="0px 10px 20px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={1.6} lg={9} xl={9} display="flex-start" justifyContent="center">
                                                    {/* <Box sx={{ borderLeft: '2px solid  #f06292' }}> */}
                                                    {/* #3498db */}
                                                    <Box
                                                        sx={{
                                                            display: 'inline-flex',
                                                            borderBottom: '2px solid #ec407a'  // Underline color
                                                        }}
                                                    >

                                                        <Typography variant="h5" marginLeft="0px" padding="3px" marginTop={0} textAlign="left" >
                                                            Planning Details
                                                        </Typography>

                                                    </Box>

                                                </Grid>


                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex" marginRight="auto" justifyContent="center">
                                                    <Typography variant="subtitle2" marginLeft="auto" marginRight="10px" >Total Reams: {numberofSheets}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container padding="0px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                            </Grid>

                                            {/* <Divider sx={{ marginBottom: "20px" }} /> */}
                                            <Grid container padding="1px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6">{t('prod_sheet_convertion.shift_code')}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1}>
                                                    <Autocomplete

                                                        fullWidth
                                                        disabled={jobID > 0}
                                                        value={winderShiftCode}
                                                        onChange={handleWinderShiftChange}
                                                        size="small"
                                                        style={{ fontSize: '12px' }}
                                                        options={shiftCodes}
                                                        getOptionLabel={(option) => `${option.shiftcode}`}

                                                        renderInput={(params) =>
                                                            <TextField required
                                                                helperText={errorMessage}
                                                                error={errorMessage && errorMessage.length ? true : false}
                                                                {...params} variant="outlined" />}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6" marginLeft={1}>{t('prod_sheet_convertion.shift_date_time')}</Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5}>
                                                    <FormControl fullWidth size="small">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <Stack spacing={1} >
                                                                <DatePicker

                                                                    value={dayjs(shiftDate)}
                                                                    onChange={(date) => setShiftDate(date)}
                                                              
                                                                          slotProps={{ textField: { size: 'small' }, field: { format: 'DD-MMM-YYYY' } }}
                                                                    fullWidth
                                                                    disabled={jobID > 0}
                                                                    renderInput={(props) => (
                                                                        <TextField
                                                                            helperText={shiftdate_errorMessage}
                                                                            error={shiftdate_errorMessage && shiftdate_errorMessage.length ? true : false}
                                                                            {...props} />
                                                                    )}

                                                                />
                                                            </Stack>
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>


                                            </Grid>
                                        </Grid>

                                        <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">


                                            <Grid item xs={12} sm={12} md={1.6} lg={1.55} xl={1.05} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_reampallet.sheets_in_ream_pallet')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                <TextField
                                                    fullWidth
                                                    disabled={jobID > 0}
                                                    // disabled={disableNumberofSheets}
                                                    size="small"
                                                    required
                                                    type='number'
                                                    value={sheeterNoOfSheets}
                                                    onChange={(e) => setSheeterNoOfSheets(e.target.value)}

                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_reampallet.Supervisor')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={selectedOperator}
                                                    onChange={handleOperatorChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={operator}
                                                    getOptionLabel={(option) => `${option.operator_code}`}
                                                    renderInput={(params) =>
                                                        <TextField required

                                                            {...params} variant="outlined" />}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_reams.fno')}</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} display="flex-start" justifyContent="center">
                                                <TextField
                                                    fullWidth
                                                    // disabled={disableNumberofSheets}
                                                    size="small"
                                                    required
                                                    type='number'
                                                    value={fNo}
                                                    onChange={(e) => setFNo(e.target.value)}

                                                />
                                            </Grid>

                                        </Grid>

                                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                        {sheeterNoOfSheets != 0 && (


                                            <Grid container padding="10px 0px 5px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                <Grid item xs={11} sm={11} md={10} lg={11.9} xl={11.9} display="flex-start" justifyContent="center">

                                                    <Grid container padding="0px 5px 5px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">


                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="Back to Line item wise achieved reams ">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">Total Ream Pallet</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{numberofReams || 0}</Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">Total L Ream Pallet</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{lossReams || 0}</Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">Ream Pallet Weight in Kgs</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{reamWeignt || 0} </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6"> L Ream Pallet Weight in Kgs</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{lReamWeignt || 0} </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


                                                        {jobID === 0 && (
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <Button variant="contained" onClick={InsertBundleDetails} disabled={disableSaveBtn} color="secondary" size="small">Proceed</Button>

                                                                </Box>
                                                            </Grid>
                                                        )}


                                                    </Grid>


                                                </Grid>

                                            </Grid>
                                        )}
                                        {jobID > 0 && (
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                    {/* <Button startIcon={<EditIcon />} sx={{ mr: '10px' }} variant="contained"  color="secondary" size="small">Update</Button> */}

                                                    {hasPermission(userPermissions, "Ream Pallet", "Update") && (
                                                        <Tooltip title="Update ReamPallet Job Details" >
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                onClick={handleUpdate}
                                                                startIcon={<Edit />}
                                                                size="small"
                                                                sx={{ mr: '5px' }}
                                                            >
                                                                Update
                                                            </Button>
                                                        </Tooltip>
                                                    )}



                                                    {hasPermission(userPermissions, "Ream Pallet", "Delete") && (
                                                        <Tooltip title="Delete Bundle Job Details" >
                                                            <Button variant="contained" size="small" onClick={DeleteReamPalletProductionJobDetails} startIcon={<DeleteForeverOutlinedIcon />} sx={{ backgroundColor: '#e57373' }} >Delete</Button>
                                                        </Tooltip>
                                                    )}


                                                </Box>
                                            </Grid>
                                        )}

                                    </Grid>

                                    {viewReamQRCode && (
                                        <>
                                            {/* <Box sx={{ backgroundColor: colors.primary[400], marginTop: "1px", border: "1px solid ", borderColor: colors.primary[300], borderRadius: "2px" }}> */}
                                            <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid mt={2} mb={0.5} item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                    <Typography variant="h5" fontWeight="bold" marginTop={0} textAlign="left">
                                                        Ream Pallet List
                                                    </Typography>
                                                </Grid>

                                            </Grid>

                                            {/* </Box> */}
                                            <Divider sx={{ marginTop: "10px" }} />

                                            <Grid container padding="1px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={11} sm={11} md={11} lg={7} xl={5} display="flex-start" justifyContent="center">
                                                    <CustomTableContainer colors={colors}>
                                                        {reamPalletListLoding ? (
                                                            <SkeletonTableLoader rows={5} columns={11} />
                                                        ) : (
                                                            <TableContainer >
                                                                <Table size="small">
                                                                    <TableHead sx={{ height: 10 }}>
                                                                        <TableRow>
                                                                            <TableCell>
                                                                                <Checkbox size="small" sx={{

                                                                                    color: 'secondary' // Custom color
                                                                                }}
                                                                                    indeterminate={selectedReamRows.length > 0 && selectedReamRows.length < filteredReamData.length}
                                                                                    checked={selectedReamRows.length === filteredReamData.length}
                                                                                    onChange={handleSelectAllClickPallet}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>REAM PALLET CODE</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>NUMBER OF REAMS</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>REAM PALLET WEIGHT</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>GROSS WEIGHT</TableCell>
                                                                             <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {reamList.map((row, index) => (
                                                                            <TableRow key={row.id_ream_pallet_val}>
                                                                                <TableCell>
                                                                                    <Checkbox
                                                                                        size="small"
                                                                                        sx={{

                                                                                            color: 'secondary' // Custom color
                                                                                        }}
                                                                                        checked={isSelectedReam(row.id_ream_pallet_val)}
                                                                                        // disabled={row.status === 'converted'}
                                                                                        onChange={(event) => handleRowCheckboxClickPallet(event, row.id_ream_pallet_val)}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell sx={{ textAlign: "left" }}>{row.ream_pallet_number}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.no_of_reams}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.ream_pallet_weight}</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>
                                                                                    <TextField
                                                                                        fullWidth
                                                                                        size="small"
                                                                                        sx={{
                                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                                border: 'none',
                                                                                            },
                                                                                            '& .MuiInputBase-input': {
                                                                                                padding: '8px',
                                                                                                textAlign: 'right',
                                                                                            },
                                                                                        }}
                                                                                        variant="outlined"
                                                                                        type="number"
                                                                                        value={row.ream_pallet_gross_weight}
                                                                                        onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                                                    />
                                                                                </TableCell>

                                                                                 <TableCell sx={{ textAlign: "center" }}>
                                                                                        <Chip
                                                                                        label={row.status === "true" ? "Converted" : "Approved"}
                                                                                        size="small"
                                                                                        sx={{
                                                                                        color: "#fff",
                                                                                        background:
                                                                                        row.status === "true"
                                                                                        ? "linear-gradient(45deg, #00838f, #0097a7)"
                                                                                        : "linear-gradient(45deg, #388e3c, #2e7d32)",
                                                                                        }}
                                                                                        />
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        )}
                                                    </CustomTableContainer>
                                                </Grid>
                                            </Grid>

                                            <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                <Box sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

                                                    <Toolbar>
                                                        <Button type="submit" onClick={() => viewQRCode()} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ textTransform: 'none' }}>{t('prod_sheet_convertion.btn_view_qr')}</Button>
                                                        <Button type="submit" onClick={() => handleButtonClick('PrintQRAll')} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ marginLeft: '10px', textTransform: 'none' }}>{t('prod_sheet_convertion.btn_print_qr')}</Button>
                                                        <Button type="submit" onClick={() => handleButtonClickNew('PrintQRAll')} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ marginLeft: '10px', textTransform: 'none' }}>{t('prod_sheet_convertion.btn_print_qr_new')}</Button>
                                                        <Button type="submit" onClick={() => handleUpdateGrossWeight()} size="small" variant="contained" color="secondary" startIcon={<EditSquareIcon />} sx={{ marginLeft: '10px', textTransform: 'none' }}>{t('prod_sheet_convertion.btn_update_gross_weight')}</Button>
                                                        {jobID > 0 && (
                                                            <Button type="submit" onClick={() => DeleteSelectedReamPalletsProductionJobDetails()} size="small" variant="contained" startIcon={<DeleteForeverOutlinedIcon />} sx={{ marginLeft: '10px', textTransform: 'none', backgroundColor: '#e57373' }}>Delete</Button>
                                                        )}
                                                    </Toolbar>
                                                </Box>

                                            </Grid>

                                            <Divider sx={{ marginTop: "10px" }} />

                                            <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item mt={1} sm={11} md={11} lg={6} xl={4} >
                                                    <div>
                                                        {selectedReamDetails && selectedReamDetails.length > 0 && (

                                                            <LabelReamPalletDetails qrCodeValue={''} ProductDetail={selectedReamDetails} />
                                                        )}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}


                                    <Grid container padding="20px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                            <Accordion   >
                                                {/*sx={{ backgroundColor: colors.primary[500] }} */}
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.875rem" }} />}
                                                    sx={{
                                                        minHeight: "28px", // Smaller height for compactness
                                                        padding: "0 8px", // Reduced padding
                                                        // backgroundColor: colors.primary[400],
                                                        borderRadius: "2px",
                                                        "& .MuiAccordionSummary-content": {
                                                            margin: 0,
                                                            fontSize: "0.75rem", // Smaller font for a compact appearance
                                                            fontWeight: "bold",
                                                        },
                                                        "&.Mui-expanded": {
                                                            minHeight: "24px", // Keeps the header thin even when expanded
                                                        },
                                                    }}
                                                >
                                                    <Box display="flex" alignItems="center">
                                                        {/* Add the icon here */}
                                                        <InfoIcon sx={{ marginRight: '4px', fontSize: 16, color: colors.blueAccent[500] }} />
                                                        <Typography variant="subtitle2">View Customer Details</Typography>
                                                    </Box>


                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box
                                                        sx={{
                                                            // backgroundColor: colors.primary[700],
                                                            // padding: "10px",
                                                            borderRadius: "10px",
                                                            // marginTop: "10px",
                                                            maxHeight: {
                                                                xs: '72vh', // Extra small devices (phones)
                                                                sm: '72vh', // Small devices (tablets)
                                                                md: '74vh', // Medium devices (small laptops)
                                                                lg: '30vh', // Large devices (desktops)
                                                                xl: '30vh', // Extra large devices (large desktops)
                                                            },
                                                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                            '&::-webkit-scrollbar': {
                                                                width: '8px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: colors.primary[400],
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: colors.blueAccent[600],
                                                                borderRadius: '10px',
                                                                '&:hover': {
                                                                    background: colors.blueAccent[800],
                                                                },
                                                            },
                                                            '&::-webkit-scrollbar-corner': {
                                                                background: colors.primary[700],
                                                            }
                                                        }}>
                                                        <>
                                                            <CustomTableContainer colors={colors}>

                                                                <TableContainer >
                                                                    <Table size="small">
                                                                        <TableHead sx={{ height: 0 }}>
                                                                            <TableRow>

                                                                                <TableCell sx={{ textAlign: "center" }}>CO DATE</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>CO NUMBER</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>CUSTOMER NAME</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>SUPPLIER NAME</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>WIDTH</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>LENGTH</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>PRODUCED REAMS</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>ACH.QTY</TableCell>

                                                                                <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>NO.OF.SHEETS IN REAM</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>LINE NUMBER</TableCell>
                                                                                <TableCell>
                                                                                    <IconButton >
                                                                                        {/* onClick={handleOpen} */}
                                                                                        <Searchicon style={{ fontSize: "16px" }} />
                                                                                    </IconButton>
                                                                                    <Modal
                                                                                        // open={open}
                                                                                        // onClose={handleClose}
                                                                                        aria-labelledby="modal-modal-title"
                                                                                        aria-describedby="modal-modal-description"
                                                                                    >
                                                                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                            <TextField
                                                                                                label="Parent Roll Number"
                                                                                                name="name"
                                                                                                // value={filters.pr_number}
                                                                                                // onChange={handleFilterChange}
                                                                                                variant="outlined"
                                                                                                fullWidth
                                                                                                margin="normal"
                                                                                            />
                                                                                            <TextField
                                                                                                label="MA Number"
                                                                                                name="companyName"
                                                                                                // value={filters.release_no}
                                                                                                // onChange={handleFilterChange}
                                                                                                variant="outlined"
                                                                                                fullWidth
                                                                                                margin="normal"
                                                                                            />

                                                                                            <TextField
                                                                                                label="Status"
                                                                                                name="status"
                                                                                                // value={filters.status}
                                                                                                // onChange={handleFilterChange}
                                                                                                variant="outlined"
                                                                                                fullWidth
                                                                                                margin="normal"
                                                                                            />


                                                                                            <Button variant="contained" style={{ marginTop: 10 }}>
                                                                                                {/* onClick={handleClose}  */}
                                                                                                Apply Filter
                                                                                            </Button>
                                                                                        </Box>
                                                                                    </Modal>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {selectedLineItemDetail.map((row) => (
                                                                                <TableRow key={row.id}>

                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.indent_date}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "left", fontWeight: "bold" }}>
                                                                                        <span
                                                                                            style={{ color: '#039be5', textDecoration: 'underline', cursor: 'pointer' }}
                                                                                            onClick={() => handleCallEdit(row.indent_no, row.line_no)}
                                                                                        >
                                                                                            {row.indent_no} / {row.line_no}
                                                                                        </span>
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ textAlign: "left" }}>{row.customer_name}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "left" }}>{row.supplier_name}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.d_width}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.d_length}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.reel_count}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.total_qty}</TableCell>

                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.line_no}</TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </CustomTableContainer>

                                                        </>
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="5px 0px 0px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"  >
                                        <Grid item xs={11} sm={11} md={11} lg={12} xl={12} display="flex-start" justifyContent="center" marginBottom="auto">
                                            <Accordion   >
                                                {/*sx={{ backgroundColor: colors.primary[500] }} */}
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.875rem" }} />}
                                                    sx={{
                                                        minHeight: "28px", // Smaller height for compactness
                                                        padding: "0 8px", // Reduced padding
                                                        // backgroundColor: colors.primary[400],
                                                        borderRadius: "2px",
                                                        "& .MuiAccordionSummary-content": {
                                                            margin: 0,
                                                            fontSize: "0.75rem", // Smaller font for a compact appearance
                                                            fontWeight: "bold",
                                                        },
                                                        "&.Mui-expanded": {
                                                            minHeight: "24px", // Keeps the header thin even when expanded
                                                        },
                                                    }}
                                                >
                                                    <Box display="flex" alignItems="center">
                                                        {/* Add the icon here */}
                                                        <InfoIcon sx={{ marginRight: '4px', fontSize: 16, color: colors.blueAccent[500] }} />
                                                        <Typography variant="subtitle2">View Selected Reams</Typography>
                                                    </Box>


                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box
                                                        sx={{
                                                            // backgroundColor: colors.primary[700],
                                                            // padding: "10px",
                                                            borderRadius: "10px",
                                                            // marginTop: "10px",
                                                            maxHeight: {
                                                                xs: '72vh', // Extra small devices (phones)
                                                                sm: '72vh', // Small devices (tablets)
                                                                md: '74vh', // Medium devices (small laptops)
                                                                lg: '30vh', // Large devices (desktops)
                                                                xl: '30vh', // Extra large devices (large desktops)
                                                            },
                                                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                            '&::-webkit-scrollbar': {
                                                                width: '8px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: colors.primary[400],
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: colors.blueAccent[600],
                                                                borderRadius: '10px',
                                                                '&:hover': {
                                                                    background: colors.blueAccent[800],
                                                                },
                                                            },
                                                            '&::-webkit-scrollbar-corner': {
                                                                background: colors.primary[700],
                                                            }
                                                        }}>
                                                        <>
                                                            <CustomTableContainer colors={colors}>
                                                                <TableContainer>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell sx={{ textAlign: "center" }}>REAM NUMBER</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>SIZE</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>WEIGHT</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>NO OF SHEETS</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {selectedReelList.map((row) => (
                                                                                <TableRow key={row.id_reel}>

                                                                                    <TableCell sx={{ textAlign: "center" }}>
                                                                                        {/* {row.ream_code} */}
                                                                                        <span
                                                                                            style={{ color: '#039be5', cursor: 'pointer' }}

                                                                                        >
                                                                                            {row.ream_code}
                                                                                        </span>
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.item_code}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.sheet_size}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.ream_weight}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.number_of_sheets}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.status}</TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </CustomTableContainer>
                                                        </>
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>



                                </>
                            )}


                        </>

                    </Box>

                    <Box
                        sx={{
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '74vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        {viewReamLabeling && (
                            <div>

                                {showCard && (
                                    <Grid container padding="15px 0px 10px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                        <Grid item xs={10.1} sm={10.6} md={11.9} lg={11.92} xl={11.95} display="flex-start" justifyContent="center">
                                            <Card sx={{ backgroundColor: colors.primary[500], borderRadius: "5px" }}>
                                                <CardContent>
                                                    <Box display="flex">
                                                        <Box>
                                                            <Typography sx={{ marginBottom: "5px" }}>Customer Details</Typography>
                                                        </Box>

                                                        <IconButton onClick={handleHide} sx={{ marginLeft: "auto" }} >
                                                            <CloseIcon style={{ color: "#ff5252", fontSize: "16px", fontWeight: "bold" }} />
                                                        </IconButton>

                                                    </Box>

                                                    <CustomTableContainer colors={colors}>
                                                        <Table >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Customer Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Supplier Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Indent Number</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Indent Date</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Line Number</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Master Reel</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Width</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Quality</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>GSM</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Diameter</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Inner Core</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Reel Length</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Reel Weight</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Number of Sheets</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Produced MO Number</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {childRollDetails?.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.customer_name || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.supplier_name || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.indent_no || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{formatDate(row.indent_date) || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.line_no || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.master_reel || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.d_width || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.quality || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.gsm || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.diameter || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.inner_core || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.reel_length || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.achieved_qty || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.no_of_sheets || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.mo_number || "N/A"}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </CustomTableContainer>
                                                </CardContent>
                                            </Card>

                                        </Grid>
                                    </Grid>
                                )}
                            </div>
                        )}
                    </Box>
                </>

            )
            }



        </Box >
    )
}
export default ReamPalletLabel;